import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Custom scalar to handle BigIntegerField values */
  BigInt: { input: any; output: any; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  /** A duration of time that can be parsed flexibly */
  Duration: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export type AllowedComparators = {
  __typename?: 'AllowedComparators';
  boolean: Array<Scalars['String']['output']>;
  json: Array<Scalars['String']['output']>;
  numeric: Array<Scalars['String']['output']>;
  string: Array<Scalars['String']['output']>;
  time: Array<Scalars['String']['output']>;
};

export type AnnouncementType = {
  __typename?: 'AnnouncementType';
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  email: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  picture: Scalars['String']['output'];
  token: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AutofixRunStepInput = {
  filesToExamine?: InputMaybe<FilesToExamineInput>;
  gitRepo?: InputMaybe<GitRepoInput>;
  informationLearned: Scalars['String']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  previousSteps?: InputMaybe<Array<Scalars['ID']['input']>>;
  promptTemplate?: InputMaybe<PromptTemplateInput>;
  reasoningContent?: InputMaybe<Scalars['String']['input']>;
  reasoningFilePath?: InputMaybe<Scalars['String']['input']>;
  run: Scalars['ID']['input'];
  state: AutofixRunStepState;
  stepType: AutofixStepTypeInput;
};

export enum AutofixRunStepState {
  Failed = 'FAILED',
  HasAlreadyBeenResolved = 'HAS_ALREADY_BEEN_RESOLVED',
  NeedsHumanIntervention = 'NEEDS_HUMAN_INTERVENTION',
  PrAwaitingReview = 'PR_AWAITING_REVIEW',
  PrMerged = 'PR_MERGED',
  PrRejected = 'PR_REJECTED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Successful = 'SUCCESSFUL'
}

export type AutofixRunStepType = {
  __typename?: 'AutofixRunStepType';
  createdAt: Scalars['DateTime']['output'];
  filesToExamine?: Maybe<FilesToExamineType>;
  gitRepo?: Maybe<GitRepoType>;
  id: Scalars['UUID']['output'];
  informationLearned: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  nextSteps: Array<AutofixRunStepType>;
  previousSteps: Array<AutofixRunStepType>;
  promptTemplate?: Maybe<PromptTemplateType>;
  reasoningFilePath?: Maybe<Scalars['String']['output']>;
  run: AutofixRunType;
  state: Scalars['String']['output'];
  stepType: AutofixStepTypeType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AutofixRunType = {
  __typename?: 'AutofixRunType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  issue: DjangoModelType;
  link?: Maybe<Scalars['String']['output']>;
  runId: Scalars['String']['output'];
  slackConversation: DjangoModelType;
  state: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AutofixStepTypeInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AutofixStepTypeType = {
  __typename?: 'AutofixStepTypeType';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
};

export type AutoinstallRunStepInput = {
  filesToExamine?: InputMaybe<FilesToExamineInput>;
  gitRepo?: InputMaybe<GitRepoInput>;
  id: Scalars['ID']['input'];
  informationLearned: Scalars['String']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  previousSteps?: InputMaybe<Array<Scalars['ID']['input']>>;
  promptTemplate?: InputMaybe<PromptTemplateInput>;
  reasoningContent?: InputMaybe<Scalars['String']['input']>;
  reasoningFilePath?: InputMaybe<Scalars['String']['input']>;
  run: Scalars['ID']['input'];
  state: AutoinstallRunStepState;
  stepType: AutoinstallStepTypeInput;
};

export enum AutoinstallRunStepState {
  Failed = 'FAILED',
  NeedsHumanIntervention = 'NEEDS_HUMAN_INTERVENTION',
  PrAwaitingReview = 'PR_AWAITING_REVIEW',
  PrMerged = 'PR_MERGED',
  PrRejected = 'PR_REJECTED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Successful = 'SUCCESSFUL'
}

export type AutoinstallRunStepType = {
  __typename?: 'AutoinstallRunStepType';
  createdAt: Scalars['DateTime']['output'];
  filesToExamine?: Maybe<FilesToExamineType>;
  gitRepo?: Maybe<GitRepoType>;
  id: Scalars['UUID']['output'];
  informationLearned: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  nextSteps: Array<AutoinstallRunStepType>;
  previousSteps: Array<AutoinstallRunStepType>;
  promptTemplate?: Maybe<PromptTemplateType>;
  reasoningFilePath?: Maybe<Scalars['String']['output']>;
  run: AutoinstallRunType;
  state: Scalars['String']['output'];
  stepType: AutoinstallStepTypeType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AutoinstallRunType = {
  __typename?: 'AutoinstallRunType';
  codeRepository?: Maybe<DjangoModelType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  runId: Scalars['String']['output'];
  slackConversation: DjangoModelType;
  state: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AutoinstallStepTypeInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AutoinstallStepTypeType = {
  __typename?: 'AutoinstallStepTypeType';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
};

export type BigQueryResultsType = {
  __typename?: 'BigQueryResultsType';
  queryType: Scalars['String']['output'];
  results: BigQueryVaryingStructurePaginationWindow;
  tree: Scalars['String']['output'];
};

export type BigQueryVaryingStructure = {
  __typename?: 'BigQueryVaryingStructure';
  data: Scalars['JSON']['output'];
};

export type BigQueryVaryingStructurePaginationWindow = {
  __typename?: 'BigQueryVaryingStructurePaginationWindow';
  /** The list of items in this pagination window. */
  items: Array<BigQueryVaryingStructure>;
  /** Total number of items in the filtered dataset. */
  totalItemsCount: Scalars['Int']['output'];
};

export type BranchDiff = {
  __typename?: 'BranchDiff';
  mainNotInProduction: Array<Scalars['Int']['output']>;
  productionNotInMain: Array<Scalars['Int']['output']>;
};

export type CaptureSettingsInput = {
  collectFonts?: InputMaybe<Scalars['Boolean']['input']>;
  cssFromDomain?: InputMaybe<Scalars['String']['input']>;
  cssToDomain?: InputMaybe<Scalars['String']['input']>;
  ignoreDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  inlineImages?: InputMaybe<Scalars['Boolean']['input']>;
  recordCanvas?: InputMaybe<Scalars['Boolean']['input']>;
  recordCreditCardInfo?: InputMaybe<Scalars['Boolean']['input']>;
  recordCrossOriginIframes?: InputMaybe<Scalars['Boolean']['input']>;
  recordDob?: InputMaybe<Scalars['Boolean']['input']>;
  recordPassword?: InputMaybe<Scalars['Boolean']['input']>;
  recordRealName?: InputMaybe<Scalars['Boolean']['input']>;
  recordSsn?: InputMaybe<Scalars['Boolean']['input']>;
  sampling?: InputMaybe<Scalars['JSON']['input']>;
};

export type CaptureSettingsType = {
  __typename?: 'CaptureSettingsType';
  canEdit: Scalars['Boolean']['output'];
  collectFonts: Scalars['Boolean']['output'];
  cssFromDomain?: Maybe<Scalars['String']['output']>;
  cssToDomain?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ignoreDomains: Array<Scalars['String']['output']>;
  inlineImages: Scalars['Boolean']['output'];
  recordCanvas: Scalars['Boolean']['output'];
  recordCreditCardInfo: Scalars['Boolean']['output'];
  recordCrossOriginIframes: Scalars['Boolean']['output'];
  recordDob: Scalars['Boolean']['output'];
  recordPassword: Scalars['Boolean']['output'];
  recordRealName: Scalars['Boolean']['output'];
  recordSsn: Scalars['Boolean']['output'];
  sampling: Scalars['JSON']['output'];
};

export type ClickInteraction = {
  __typename?: 'ClickInteraction';
  children?: Maybe<Array<Scalars['String']['output']>>;
  details: Scalars['String']['output'];
  element: Scalars['JSON']['output'];
  recordingId: Scalars['String']['output'];
  textContent: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ClientDetails = {
  __typename?: 'ClientDetails';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CompanyConfigurationSplitNonsessionApplogsBySeconds = {
  __typename?: 'CompanyConfigurationSplitNonsessionApplogsBySeconds';
  splitNonsessionApplogsBySeconds: Scalars['Int']['output'];
};

export type CompanyType = {
  __typename?: 'CompanyType';
  apiKey: Scalars['UUID']['output'];
  domains: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  users: Array<DjangoModelType>;
};

export type CreateEngineeringTicketInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  issueId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEngineeringTicketPlatformIntegrationConfig = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEngineeringTicketPlatformIntegrationInput = {
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIssueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  triageIds: Array<Scalars['String']['input']>;
};

export type DataFileStats = {
  __typename?: 'DataFileStats';
  numberOfFiles: Scalars['Int']['output'];
  totalSizeKb: Scalars['Float']['output'];
};

export type DeleteEngineeringTicketPlatformIntegrationInput = {
  companyId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
};

export type DeviceDetails = {
  __typename?: 'DeviceDetails';
  brand?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DeviceMetadata = {
  __typename?: 'DeviceMetadata';
  client?: Maybe<ClientDetails>;
  device?: Maybe<DeviceDetails>;
  isBot: Scalars['Boolean']['output'];
  isDesktop: Scalars['Boolean']['output'];
  isMobile: Scalars['Boolean']['output'];
  isTelevision: Scalars['Boolean']['output'];
  os?: Maybe<OsDetails>;
};

export type DeviceSplitInteractions = {
  __typename?: 'DeviceSplitInteractions';
  desktop: InteractionsTaken;
  mobile: InteractionsTaken;
};

export type DjangoModelType = {
  __typename?: 'DjangoModelType';
  pk: Scalars['ID']['output'];
};

export type DnsRoutingStatusType = {
  __typename?: 'DnsRoutingStatusType';
  backendApi: Scalars['Boolean']['output'];
  sailfishBackendApi: Scalars['Boolean']['output'];
};

export type EditEngineeringTicketInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  platformId?: InputMaybe<Scalars['Int']['input']>;
  platformLink?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type EditEngineeringTicketPlatformIntegrationInput = {
  defaultPriority?: InputMaybe<Scalars['Int']['input']>;
  defaultProject?: InputMaybe<Scalars['String']['input']>;
  defaultTeam?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  pushAutoIdentifiedIssues?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EditIssueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditSlackIntegrationInput = {
  defaultEngineeringCollaborationChannel?: InputMaybe<Scalars['String']['input']>;
};

export type EmailNotificationSettingsInput = {
  defaultRecipients?: InputMaybe<Scalars['JSON']['input']>;
  timeBetweenSuccessiveNotificationsPerIssue: Scalars['Duration']['input'];
};

export type EmailNotificationSettingsType = {
  __typename?: 'EmailNotificationSettingsType';
  defaultRecipients: Scalars['JSON']['output'];
  timeBetweenSuccessiveNotificationsPerIssue: Scalars['Duration']['output'];
};

export type EngineeringTicketPlatformIntegrationConfigType = {
  __typename?: 'EngineeringTicketPlatformIntegrationConfigType';
  clientId: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
};

export type EngineeringTicketPlatformIntegrationType = {
  __typename?: 'EngineeringTicketPlatformIntegrationType';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  company: DjangoModelType;
  defaultPriority?: Maybe<Scalars['Int']['output']>;
  defaultProject?: Maybe<Scalars['String']['output']>;
  defaultTeam?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  installed: Scalars['Boolean']['output'];
  installedAt?: Maybe<Scalars['DateTime']['output']>;
  installedBy?: Maybe<DjangoModelType>;
  lastWebhookEventAt?: Maybe<Scalars['DateTime']['output']>;
  projects: Scalars['JSON']['output'];
  provider: Scalars['String']['output'];
  pushAutoIdentifiedIssues: Scalars['Boolean']['output'];
  subdomain?: Maybe<Scalars['String']['output']>;
  teams: Scalars['JSON']['output'];
  type: Scalars['String']['output'];
  uninstalledBy?: Maybe<DjangoModelType>;
  updatedAt: Scalars['DateTime']['output'];
  webhookClientId: Scalars['String']['output'];
  webhookClientSecret: Scalars['String']['output'];
  webhookEnabled: Scalars['Boolean']['output'];
  webhookEventCount: Scalars['Int']['output'];
  webhookId?: Maybe<Scalars['String']['output']>;
  webhookInstalled: Scalars['Boolean']['output'];
  webhookInstalledAt?: Maybe<Scalars['DateTime']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
  workflowStates: Scalars['JSON']['output'];
};

export type EngineeringTicketType = {
  __typename?: 'EngineeringTicketType';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  platformLink?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  project?: Maybe<Scalars['String']['output']>;
  /** Engineering ticket platform provider */
  provider: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EventInput = {
  clusterName?: InputMaybe<Scalars['String']['input']>;
  details: Scalars['JSON']['input'];
  eventType: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  resourceUuid: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
};

export type EventSeenKvInput = {
  key: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type ExceptionRecordQueryResultsType = {
  __typename?: 'ExceptionRecordQueryResultsType';
  queryType: Scalars['String']['output'];
  results: ExceptionRecordTypePaginationWindow;
  tree: Scalars['String']['output'];
};

export type ExceptionRecordType = {
  __typename?: 'ExceptionRecordType';
  code?: Maybe<Scalars['String']['output']>;
  exceptionMessage?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Is the issue resolved? */
  isIssueResolved: Scalars['Boolean']['output'];
  issue?: Maybe<DjangoModelType>;
  line?: Maybe<Scalars['Int']['output']>;
  sanitizedExceptionMessage?: Maybe<Scalars['String']['output']>;
  serviceIdentifier: ServiceIdentifierType;
  timestampMs: Scalars['String']['output'];
  traceJson?: Maybe<Scalars['JSON']['output']>;
  /** Trace stack */
  traceStack: Array<TraceFrameType>;
  wasCaught: Scalars['Boolean']['output'];
};

export type ExceptionRecordTypePaginationWindow = {
  __typename?: 'ExceptionRecordTypePaginationWindow';
  /** The list of items in this pagination window. */
  items: Array<ExceptionRecordType>;
  /** Total number of items in the filtered dataset. */
  totalItemsCount: Scalars['Int']['output'];
};

export type FeatureRequestType = {
  __typename?: 'FeatureRequestType';
  /** List of companies that voted for the feature request */
  companiesVoted: Array<Scalars['String']['output']>;
  dateRequested: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUpdate: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  /** Number of votes for the feature request */
  totalVotes: Scalars['Int']['output'];
  /** Whether the user voted for the feature request */
  votedByUser: Scalars['Boolean']['output'];
};

export type FieldAutocompleteData = {
  __typename?: 'FieldAutocompleteData';
  field: Scalars['String']['output'];
  matches: Match;
};

export type FileProcessingStats = {
  __typename?: 'FileProcessingStats';
  dataFileStats: DataFileStats;
  processingTimeMs: Scalars['Float']['output'];
};

export type FilesToExamineInput = {
  lines: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
};

export type FilesToExamineType = {
  __typename?: 'FilesToExamineType';
  id: Scalars['UUID']['output'];
  lines: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
};

export type FollowIssueInput = {
  issueId: Scalars['Int']['input'];
};

export type FrontendConsoleLogs = {
  __typename?: 'FrontendConsoleLogs';
  fileProcessingStats: FileProcessingStats;
  logs: Array<Scalars['JSON']['output']>;
};

export type FullAutocompleteData = {
  __typename?: 'FullAutocompleteData';
  /** Allowed comparators for field types */
  allowedComparators: AllowedComparators;
  booleanFields: Array<TypeAheadBooleanField>;
  jsonFields: Array<TypeAheadJsonField>;
  numericFields: Array<TypeAheadNumericField>;
  textFields: Array<TypeAheadTextField>;
  timeFields: Array<TypeAheadTimeField>;
};

export type GitHubIntegrationType = {
  __typename?: 'GitHubIntegrationType';
  accountType?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  appId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  installationId?: Maybe<Scalars['String']['output']>;
  installedOnAccount?: Maybe<Scalars['String']['output']>;
  installedOnAllRepositories: Scalars['Boolean']['output'];
  installedOnRepositories: Scalars['JSON']['output'];
  repositoriesUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GitRepoInput = {
  link: Scalars['String']['input'];
  org: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  repo: Scalars['String']['input'];
};

export type GitRepoType = {
  __typename?: 'GitRepoType';
  id: Scalars['UUID']['output'];
  link: Scalars['String']['output'];
  org: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  repo: Scalars['String']['output'];
};

export type IntegrationStatusType = {
  __typename?: 'IntegrationStatusType';
  integrations: Array<IntegrationType>;
};

export type IntegrationType = {
  __typename?: 'IntegrationType';
  isWorking: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
  tooltipText: Scalars['String']['output'];
};

export type InteractionsTaken = {
  __typename?: 'InteractionsTaken';
  calculatedOnTheFly: Scalars['Boolean']['output'];
  clicks: Array<ClickInteraction>;
  pageNavigations: Array<PageNavigationInteraction>;
  textEdits: Array<TypingInteraction>;
};

export type IssueQueryResultsType = {
  __typename?: 'IssueQueryResultsType';
  queryType: Scalars['String']['output'];
  results: IssueTypePaginationWindow;
  tree: Scalars['String']['output'];
};

export type IssueType = {
  __typename?: 'IssueType';
  /** Affected % (Users) */
  affectedPercentageUsers?: Maybe<Scalars['String']['output']>;
  autofixRuns?: Maybe<AutofixRunType>;
  /** If Auto-Fix can be run for the record */
  canAutofix: Scalars['Boolean']['output'];
  /** Changes made in the last 24h */
  change24h?: Maybe<Scalars['String']['output']>;
  company: CompanyType;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Created time, human-readable timestamp */
  createdAtFormatted: Scalars['String']['output'];
  /** Identifier of who created the record */
  createdBy: Scalars['String']['output'];
  createdBySystem?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  /** Devices */
  devices?: Maybe<Array<DeviceMetadata>>;
  engineeringTicket?: Maybe<EngineeringTicketType>;
  exceptions: Array<ExceptionRecordType>;
  followers: Array<UserType>;
  hasExceptionRecords: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isResolved: Scalars['Boolean']['output'];
  lastNotifiedViaEmail?: Maybe<Scalars['DateTime']['output']>;
  lastNotifiedViaWebhook?: Maybe<Scalars['DateTime']['output']>;
  /** Last Seen */
  lastSeen: Scalars['DateTime']['output'];
  /** Priority */
  priority?: Maybe<Scalars['String']['output']>;
  /** Severity */
  severity?: Maybe<Scalars['String']['output']>;
  snoozedMode: Scalars['String']['output'];
  snoozedPermanently: Scalars['Boolean']['output'];
  snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Snoozed until time, human-readable timestamp */
  snoozedUntilFormatted?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  triages: Array<TriageType>;
  updatedAt: Scalars['DateTime']['output'];
  /** Updated time, human-readable timestamp */
  updatedAtFormatted: Scalars['String']['output'];
  /** Identifier of who last updated the record */
  updatedBy: Scalars['String']['output'];
  updatedBySystem?: Maybe<Scalars['String']['output']>;
  updatedByUser?: Maybe<DjangoModelType>;
};

export type IssueTypePaginationWindow = {
  __typename?: 'IssueTypePaginationWindow';
  /** The list of items in this pagination window. */
  items: Array<IssueType>;
  /** Total number of items in the filtered dataset. */
  totalItemsCount: Scalars['Int']['output'];
};

export type JsSnippetConfigParametersType = {
  __typename?: 'JsSnippetConfigParametersType';
  apiKey: Scalars['String']['output'];
  backendApi: Scalars['String']['output'];
  /** JS Snippet Source */
  scriptSource: Scalars['String']['output'];
};

export type Match = {
  __typename?: 'Match';
  fuzzy: Array<Scalars['String']['output']>;
  prefix: Array<Scalars['String']['output']>;
};

export type MessagingPlatformIntegrationType = {
  __typename?: 'MessagingPlatformIntegrationType';
  provider: Scalars['String']['output'];
  slackIntegration?: Maybe<SlackIntegrationType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addGithubIntegration: GitHubIntegrationType;
  authenticateUser: AuthResponse;
  authenticateUserUsingAccessToken: AuthResponse;
  authenticateUserUsingUsername: AuthResponse;
  autoExpireOldSessions: Scalars['String']['output'];
  bulkUpdateUserActions: Scalars['Int']['output'];
  closeSpecificPullRequest?: Maybe<Scalars['Void']['output']>;
  collectExceptions: Scalars['Boolean']['output'];
  collectInfrastructureResourceEvents: Scalars['Boolean']['output'];
  collectInfrastructureResources: Scalars['Boolean']['output'];
  collectLogs: Scalars['Boolean']['output'];
  collectMetadata: Scalars['Boolean']['output'];
  collectNetworkHops: Scalars['Boolean']['output'];
  collectNetworkRequest: Scalars['Boolean']['output'];
  collectPrintStatements: Scalars['Boolean']['output'];
  createAutofixRunStep: AutofixRunStepType;
  createAutoinstallRunStep: AutoinstallRunStepType;
  createContact: Scalars['Boolean']['output'];
  createEngineeringTicket?: Maybe<EngineeringTicketType>;
  createEngineeringTicketPlatformIntegration?: Maybe<EngineeringTicketPlatformIntegrationType>;
  createExceptionSimilarities: Scalars['Boolean']['output'];
  createGcsBucket: Scalars['String']['output'];
  createIssue?: Maybe<IssueType>;
  createSlackIntegration: SlackIntegrationType;
  createTriage?: Maybe<TriageType>;
  createTriageFromRecorder?: Maybe<TriageType>;
  createTriageSimilarSegments: Array<TriageSimilarSegmentType>;
  createUserAction?: Maybe<RecordingSessionUserActionType>;
  deleteEngineeringTicketPlatformIntegration: Scalars['Boolean']['output'];
  dismissAnnouncement: Scalars['Boolean']['output'];
  domainsToNotPassHeaderTo: Scalars['Boolean']['output'];
  endEventSession: Scalars['String']['output'];
  finalizeSession: Scalars['Boolean']['output'];
  followIssue: Scalars['Boolean']['output'];
  getContentJsonForSession: Scalars['JSON']['output'];
  identifyServiceDetails: Scalars['Boolean']['output'];
  ignorePrsInMainNotProduction: Scalars['Boolean']['output'];
  ignorePrsInProductionNotMain: Scalars['Boolean']['output'];
  loginUser: UserType;
  logout: Scalars['Boolean']['output'];
  manuallyTriggerAutoinstallRun: Scalars['Boolean']['output'];
  notify503ErrorFromGcs?: Maybe<Scalars['Void']['output']>;
  promotePrsToProduction: Array<PullRequest>;
  reactivateSession?: Maybe<Scalars['Void']['output']>;
  registerUser: UserType;
  reportNumberOfEventsProcessedForSessionId?: Maybe<Scalars['Void']['output']>;
  sendMessageToSlackBasicText?: Maybe<Scalars['String']['output']>;
  sendRecordingEvent: Scalars['String']['output'];
  sendRecordingEvents: Scalars['String']['output'];
  sendReplyToSlackBasicText: Scalars['String']['output'];
  snoozeIssue: SnoozeIssueUpdateStatus;
  startAutofix?: Maybe<Scalars['ID']['output']>;
  startRecordingSession: RecordingSessionType;
  submitFeatureRequest?: Maybe<FeatureRequestType>;
  syncProductionToMain: PullRequest;
  toggleIssueFollowingStatusForUser: Scalars['Boolean']['output'];
  toggleIssueResolvedStatus: Scalars['Boolean']['output'];
  toggleVote: FeatureRequestType;
  unfollowIssue: Scalars['Boolean']['output'];
  updateAutofixStatus: Scalars['Boolean']['output'];
  updateAutoinstallStatus: Scalars['Boolean']['output'];
  updateBigqueryTablesForDataset: Scalars['Boolean']['output'];
  updateCaptureSettings?: Maybe<CaptureSettingsType>;
  updateEngineeringTicket?: Maybe<EngineeringTicketType>;
  updateEngineeringTicketPlatformIntegration?: Maybe<EngineeringTicketPlatformIntegrationType>;
  updateEventsSeenOfRecording: Scalars['Boolean']['output'];
  updateIssue?: Maybe<IssueType>;
  updateNotificationSettings: Scalars['Boolean']['output'];
  updatePageVisits: Scalars['Boolean']['output'];
  updateServiceDetails: Scalars['Boolean']['output'];
  updateSiteSettings?: Maybe<SiteSettingsType>;
  updateSlackIntegration: Scalars['Boolean']['output'];
  updateTaskStatus: Scalars['Boolean']['output'];
  uploadSourceMap: Scalars['Boolean']['output'];
  validateSearchQuery: ValidationResult;
};


export type MutationAddGithubIntegrationArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  installationId: Scalars['String']['input'];
  localOnlyNoGithub?: Scalars['Boolean']['input'];
  retainGitCloneInGcs?: Scalars['Boolean']['input'];
  runJstsFrontend?: Scalars['Boolean']['input'];
  runPython?: Scalars['Boolean']['input'];
  setupAction: Scalars['String']['input'];
};


export type MutationAuthenticateUserArgs = {
  token: Scalars['String']['input'];
};


export type MutationAuthenticateUserUsingAccessTokenArgs = {
  accessToken: Scalars['String']['input'];
};


export type MutationAuthenticateUserUsingUsernameArgs = {
  username: Scalars['String']['input'];
};


export type MutationBulkUpdateUserActionsArgs = {
  actions: Array<UserActionInput>;
  sessionId: Scalars['String']['input'];
};


export type MutationCloseSpecificPullRequestArgs = {
  installationId: Scalars['String']['input'];
  pullRequestIdentifier: Scalars['String']['input'];
  repo: Scalars['String']['input'];
};


export type MutationCollectExceptionsArgs = {
  apiKey: Scalars['String']['input'];
  exceptionMessage: Scalars['String']['input'];
  library?: InputMaybe<Scalars['String']['input']>;
  reentrancyGuardPreactive?: Scalars['Boolean']['input'];
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  timestampMs: Scalars['String']['input'];
  traceJson: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
  wasCaught?: Scalars['Boolean']['input'];
};


export type MutationCollectInfrastructureResourceEventsArgs = {
  apiKey: Scalars['String']['input'];
  data: EventInput;
};


export type MutationCollectInfrastructureResourcesArgs = {
  apiKey: Scalars['String']['input'];
  data: ResourceInput;
};


export type MutationCollectLogsArgs = {
  apiKey: Scalars['String']['input'];
  contents: Scalars['String']['input'];
  level: Scalars['String']['input'];
  library?: InputMaybe<Scalars['String']['input']>;
  reentrancyGuardPreactive?: Scalars['Boolean']['input'];
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  timestampMs: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCollectMetadataArgs = {
  apiKey: Scalars['String']['input'];
  excludedFields: Array<Scalars['String']['input']>;
  library?: InputMaybe<Scalars['String']['input']>;
  override?: Scalars['Boolean']['input'];
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  timestampMs: Scalars['String']['input'];
  traitsJson: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCollectNetworkHopsArgs = {
  apiKey: Scalars['String']['input'];
  column: Scalars['String']['input'];
  entrypoint: Scalars['String']['input'];
  line: Scalars['String']['input'];
  name: Scalars['String']['input'];
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  timestampMs: Scalars['String']['input'];
};


export type MutationCollectNetworkRequestArgs = {
  data: NetworkRequestInput;
};


export type MutationCollectPrintStatementsArgs = {
  apiKey: Scalars['String']['input'];
  contents: Scalars['String']['input'];
  library?: InputMaybe<Scalars['String']['input']>;
  reentrancyGuardPreactive?: Scalars['Boolean']['input'];
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  timestampMs: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAutofixRunStepArgs = {
  input: AutofixRunStepInput;
};


export type MutationCreateAutoinstallRunStepArgs = {
  input: AutoinstallRunStepInput;
};


export type MutationCreateContactArgs = {
  waitlistSignupInput: WaitlistSignupInput;
};


export type MutationCreateEngineeringTicketArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  input: CreateEngineeringTicketInput;
};


export type MutationCreateEngineeringTicketPlatformIntegrationArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  input: CreateEngineeringTicketPlatformIntegrationInput;
  inputProvider: CreateEngineeringTicketPlatformIntegrationConfig;
};


export type MutationCreateExceptionSimilaritiesArgs = {
  exceptionRecordId: Scalars['String']['input'];
  similarities: Array<SimilarityInput>;
};


export type MutationCreateIssueArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  createEngineeringTicket?: InputMaybe<Scalars['Boolean']['input']>;
  input: CreateIssueInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSlackIntegrationArgs = {
  code: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateTriageArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  triageInfoLogs?: InputMaybe<Array<TriageInputLogs>>;
  triageInfoRecordings?: InputMaybe<Array<TriageInputRecording>>;
  triageInfoSegment?: InputMaybe<TriageInputSegment>;
};


export type MutationCreateTriageFromRecorderArgs = {
  apiKey: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  recordingSessionId: Scalars['String']['input'];
  timestampEnd: Scalars['String']['input'];
  timestampStart: Scalars['String']['input'];
};


export type MutationCreateTriageSimilarSegmentsArgs = {
  segments: Array<SegmentInput>;
  triageId: Scalars['Int']['input'];
};


export type MutationCreateUserActionArgs = {
  input: RecordingSessionUserActionInput;
};


export type MutationDeleteEngineeringTicketPlatformIntegrationArgs = {
  input: DeleteEngineeringTicketPlatformIntegrationInput;
};


export type MutationDismissAnnouncementArgs = {
  announcementId: Scalars['Int']['input'];
};


export type MutationDomainsToNotPassHeaderToArgs = {
  apiKey: Scalars['String']['input'];
  domains: Array<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEndEventSessionArgs = {
  companyApiKey: Scalars['UUID']['input'];
  sessionId: Scalars['String']['input'];
};


export type MutationFinalizeSessionArgs = {
  sessionId: Scalars['String']['input'];
  textContentLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFollowIssueArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  input: FollowIssueInput;
};


export type MutationGetContentJsonForSessionArgs = {
  endTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  sessionId: Scalars['String']['input'];
  startTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  taskType?: Scalars['String']['input'];
  textContentLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationIdentifyServiceDetailsArgs = {
  apiKey: Scalars['String']['input'];
  gitSha?: InputMaybe<Scalars['String']['input']>;
  infrastructureDetails?: InputMaybe<Scalars['JSON']['input']>;
  infrastructureType?: InputMaybe<Scalars['String']['input']>;
  library: Scalars['String']['input'];
  serviceAdditionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  serviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  serviceUuid: Scalars['String']['input'];
  serviceVersion?: InputMaybe<Scalars['String']['input']>;
  setupInterceptorsFilePath?: InputMaybe<Scalars['String']['input']>;
  setupInterceptorsLineNumber?: InputMaybe<Scalars['Int']['input']>;
  timestampMs: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type MutationIgnorePrsInMainNotProductionArgs = {
  companyId: Scalars['Int']['input'];
  installationId: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
};


export type MutationIgnorePrsInProductionNotMainArgs = {
  companyId: Scalars['Int']['input'];
  installationId: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
};


export type MutationLoginUserArgs = {
  input: UserInput;
};


export type MutationPromotePrsToProductionArgs = {
  companyId: Scalars['Int']['input'];
  installationId: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  prNumbers: Array<Scalars['Int']['input']>;
  previewMode?: InputMaybe<Scalars['Boolean']['input']>;
  repo: Scalars['String']['input'];
};


export type MutationReactivateSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationRegisterUserArgs = {
  input: UserInput;
};


export type MutationReportNumberOfEventsProcessedForSessionIdArgs = {
  eventCounts?: InputMaybe<Scalars['JSON']['input']>;
  lastEventTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  numberOfEvents?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['String']['input'];
};


export type MutationSendMessageToSlackBasicTextArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
  replyToMessageUuid?: InputMaybe<Scalars['String']['input']>;
  threadTs?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendRecordingEventArgs = {
  companyApiKey: Scalars['UUID']['input'];
  event: Scalars['JSON']['input'];
  sessionId: Scalars['String']['input'];
};


export type MutationSendRecordingEventsArgs = {
  companyApiKey: Scalars['UUID']['input'];
  events: Array<Scalars['JSON']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type MutationSendReplyToSlackBasicTextArgs = {
  message: Scalars['String']['input'];
  replyToMessageUuid: Scalars['String']['input'];
};


export type MutationSnoozeIssueArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  input: SnoozeIssueInput;
};


export type MutationStartAutofixArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  issueId: Scalars['Int']['input'];
};


export type MutationStartRecordingSessionArgs = {
  companyApiKey: Scalars['UUID']['input'];
  gitSha?: InputMaybe<Scalars['String']['input']>;
  library?: InputMaybe<Scalars['String']['input']>;
  mapUuid?: InputMaybe<Scalars['String']['input']>;
  pageSplitRecordingPossible?: Scalars['Boolean']['input'];
  serviceAdditionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  serviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  serviceVersion?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['UUID']['input'];
  startRecordingFilePath?: InputMaybe<Scalars['String']['input']>;
  startRecordingLineNumber?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitFeatureRequestArgs = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationSyncProductionToMainArgs = {
  companyId: Scalars['Int']['input'];
  installationId: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
};


export type MutationToggleIssueFollowingStatusForUserArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  input: ToggleFollowIssueInput;
};


export type MutationToggleIssueResolvedStatusArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  input: ResolveIssueInput;
};


export type MutationToggleVoteArgs = {
  requestId: Scalars['ID']['input'];
};


export type MutationUnfollowIssueArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  input: FollowIssueInput;
};


export type MutationUpdateAutofixStatusArgs = {
  codeChangeLink?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  state: AutofixRunStepState;
};


export type MutationUpdateAutoinstallStatusArgs = {
  codeChangeLink?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  state: AutoinstallRunStepState;
};


export type MutationUpdateBigqueryTablesForDatasetArgs = {
  name: Scalars['String']['input'];
};


export type MutationUpdateCaptureSettingsArgs = {
  input: CaptureSettingsInput;
};


export type MutationUpdateEngineeringTicketArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  input: EditEngineeringTicketInput;
};


export type MutationUpdateEngineeringTicketPlatformIntegrationArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  input: EditEngineeringTicketPlatformIntegrationInput;
};


export type MutationUpdateEventsSeenOfRecordingArgs = {
  eventsCount: Scalars['Int']['input'];
  eventsSeenKv: Array<EventSeenKvInput>;
  sessionId: Scalars['String']['input'];
};


export type MutationUpdateIssueArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  input: EditIssueInput;
  priority?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateNotificationSettingsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  emailSettings?: InputMaybe<EmailNotificationSettingsInput>;
  webhookSettings?: InputMaybe<WebhookNotificationSettingsInput>;
  webhooks?: InputMaybe<Array<NotificationWebhookInput>>;
};


export type MutationUpdatePageVisitsArgs = {
  pageVisits: Array<PageVisitInput>;
  sessionId: Scalars['String']['input'];
};


export type MutationUpdateServiceDetailsArgs = {
  apiKey: Scalars['String']['input'];
  gitSha?: InputMaybe<Scalars['String']['input']>;
  serviceAdditionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  serviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  serviceUuid: Scalars['String']['input'];
  serviceVersion?: InputMaybe<Scalars['String']['input']>;
  timestampMs: Scalars['String']['input'];
};


export type MutationUpdateSiteSettingsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  input: SiteSettingsInput;
};


export type MutationUpdateSlackIntegrationArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  input: EditSlackIntegrationInput;
};


export type MutationUpdateTaskStatusArgs = {
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  taskId: Scalars['UUID']['input'];
  taskStatus: Scalars['String']['input'];
  triageId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUploadSourceMapArgs = {
  apiKey: Scalars['String']['input'];
  mapUuid: Scalars['String']['input'];
  sourceMap: Scalars['Upload']['input'];
};


export type MutationValidateSearchQueryArgs = {
  searchQuery: Scalars['String']['input'];
};

export type NetworkRequestDataCollective = {
  __typename?: 'NetworkRequestDataCollective';
  fileProcessingStats: FileProcessingStats;
  networkRequestData: Array<NetworkRequestDataIndividual>;
};

export type NetworkRequestDataIndividual = {
  __typename?: 'NetworkRequestDataIndividual';
  exceptions: Array<Scalars['JSON']['output']>;
  fileProcessingStats: FileProcessingStats;
  logs: Array<Scalars['JSON']['output']>;
  printStatements: Array<Scalars['JSON']['output']>;
  requestId: Scalars['String']['output'];
};

export type NetworkRequestInput = {
  apiKey: Scalars['String']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  pageVisitId?: InputMaybe<Scalars['UUID']['input']>;
  recordingSessionId: Scalars['String']['input'];
  requestId: Scalars['UUID']['input'];
  responseCode: Scalars['Int']['input'];
  serviceUuid: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
  timestampEnd: Scalars['BigInt']['input'];
  timestampStart: Scalars['BigInt']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type NetworkRequestType = {
  __typename?: 'NetworkRequestType';
  error?: Maybe<Scalars['String']['output']>;
  method: Scalars['String']['output'];
  pageVisitId?: Maybe<Scalars['UUID']['output']>;
  recording: DjangoModelType;
  requestId: Scalars['UUID']['output'];
  responseCode: Scalars['Int']['output'];
  serviceIdentifier?: Maybe<DjangoModelType>;
  success: Scalars['Boolean']['output'];
  timestampEnd: Scalars['BigInt']['output'];
  timestampStart: Scalars['BigInt']['output'];
  url: Scalars['String']['output'];
};

export type NetworkRequestsAndLogsForPageVisitUuid = {
  __typename?: 'NetworkRequestsAndLogsForPageVisitUuid';
  frontendConsoleLogs: FrontendConsoleLogs;
  networkRequestData: NetworkRequestDataCollective;
  pageVisitUuid: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type NewRecordingSessionQueryResultsGroupedType = {
  __typename?: 'NewRecordingSessionQueryResultsGroupedType';
  sessions: NewRecordingSessionType;
  userId: Scalars['String']['output'];
};

export type NewRecordingSessionQueryResultsGroupedTypePaginationWindow = {
  __typename?: 'NewRecordingSessionQueryResultsGroupedTypePaginationWindow';
  /** The list of items in this pagination window. */
  items: Array<NewRecordingSessionQueryResultsGroupedType>;
  /** Total number of items in the filtered dataset. */
  totalItemsCount: Scalars['Int']['output'];
};

export type NewRecordingSessionQueryResultsType = {
  __typename?: 'NewRecordingSessionQueryResultsType';
  queryType: Scalars['String']['output'];
  results: NewRecordingSessionQueryResultsGroupedTypePaginationWindow;
  tree: Scalars['String']['output'];
};

export type NewRecordingSessionType = {
  __typename?: 'NewRecordingSessionType';
  id: Scalars['Int']['output'];
  latestActionTimestamp: Scalars['BigInt']['output'];
  sessionCount: Scalars['Int']['output'];
  sessionItems: Array<SessionItemType>;
};

export type NotificationWebhookInput = {
  authentication?: InputMaybe<Scalars['JSON']['input']>;
  destinationAddress: Scalars['String']['input'];
  webhookDataType?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationWebhookType = {
  __typename?: 'NotificationWebhookType';
  authentication?: Maybe<Scalars['JSON']['output']>;
  destinationAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  webhookDataType: Scalars['String']['output'];
};

export type NotificationsSettingsType = {
  __typename?: 'NotificationsSettingsType';
  emailNotificationSettings: EmailNotificationSettingsType;
  notificationWebhooks: Array<NotificationWebhookType>;
  webhookNotificationSettings: WebhookNotificationSettingsType;
};

export type OsDetails = {
  __typename?: 'OSDetails';
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PageNavigationInteraction = {
  __typename?: 'PageNavigationInteraction';
  details: Scalars['String']['output'];
  recordingId: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type PageVisitInput = {
  timestamp: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type PageVisitType = {
  __typename?: 'PageVisitType';
  activeFrom: Scalars['String']['output'];
  activeUntil?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  pageUrl?: Maybe<DjangoModelType>;
  url: Scalars['String']['output'];
};

export type PaginatedAnnouncements = {
  __typename?: 'PaginatedAnnouncements';
  announcements: Array<AnnouncementType>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PromptTemplateInput = {
  name: Scalars['String']['input'];
  template: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type PromptTemplateType = {
  __typename?: 'PromptTemplateType';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  template: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type PullRequest = {
  __typename?: 'PullRequest';
  htmlUrl: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  allAnnouncements: PaginatedAnnouncements;
  autofixRunMermaid: Scalars['String']['output'];
  autoinstallRunMermaid: Scalars['String']['output'];
  captureSettings?: Maybe<CaptureSettingsType>;
  captureSettingsFromApiKey?: Maybe<CaptureSettingsType>;
  companies: Array<CompanyType>;
  company: CompanyType;
  currentUser: UserType;
  diffPrsBetweenMainAndProd: BranchDiff;
  dnsRoutingStatus?: Maybe<DnsRoutingStatusType>;
  featureRequests: Array<FeatureRequestType>;
  fetchSessionLogs: Array<NetworkRequestsAndLogsForPageVisitUuid>;
  getActiveGithubIntegrationForOwner?: Maybe<GitHubIntegrationType>;
  getAutocompleteDataForField?: Maybe<FieldAutocompleteData>;
  getAutofixRunStatus: AutofixRunType;
  getChecksForPullRequest: Scalars['JSON']['output'];
  getEngineeringTicket?: Maybe<EngineeringTicketType>;
  getEngineeringTicketPlatformIntegration?: Maybe<EngineeringTicketPlatformIntegrationType>;
  getEngineeringTicketPlatformIntegrationConfigs: Array<EngineeringTicketPlatformIntegrationConfigType>;
  getEngineeringTicketPlatformIntegrations: Array<EngineeringTicketPlatformIntegrationType>;
  getEngineeringTickets: Array<EngineeringTicketType>;
  getExceptionRecord?: Maybe<ExceptionRecordType>;
  getExceptionRecordFromApiKeyAndId?: Maybe<ExceptionRecordType>;
  getFieldValues: Array<Scalars['String']['output']>;
  getFullAutocompleteData?: Maybe<FullAutocompleteData>;
  getGithubIntegrations: Array<GitHubIntegrationType>;
  getGroupedRecordingSessionsForUser: RecordingSessionQueryResultsGroupedType;
  getIssue?: Maybe<IssueType>;
  getIssueFromIssueIdAndApiKey?: Maybe<IssueType>;
  getMessagingPlatformIntegrations: Array<MessagingPlatformIntegrationType>;
  getModifiedOrAddedFilesForPullRequest: Array<Scalars['String']['output']>;
  getNetworkRequestStatusesForRecordingSession: Array<NetworkRequestType>;
  getNotificationSettings: NotificationsSettingsType;
  getRepoDefaultTargetBranch?: Maybe<Scalars['String']['output']>;
  getSessionIdsAndTimeWindowsForIssue: SessionIdsAndTimeWindows;
  getTriage?: Maybe<TriageType>;
  jsSnippetConfigParameters?: Maybe<JsSnippetConfigParametersType>;
  latestBannerAnnouncement?: Maybe<AnnouncementType>;
  listSlackChannels?: Maybe<Array<SlackChannel>>;
  recordingSession?: Maybe<RecordingSessionEvents>;
  searchUsingQuery?: Maybe<RecordingSessionQueryResultsTypeIssueQueryResultsTypeTriageQueryResultsTypeExceptionRecordQueryResultsTypeBigQueryResultsTypeNewRecordingSessionQueryResultsType>;
  sessionDetailsForKafkaFromApiKey: SessionDetailsForKafka;
  sessionDetailsForKafkaFromSessionId?: Maybe<SessionDetailsForKafka>;
  siteSettings?: Maybe<SiteSettingsType>;
  splitNonsessionApplogsBySecondsForApiKey: CompanyConfigurationSplitNonsessionApplogsBySeconds;
  statusItems?: Maybe<IntegrationStatusType>;
  triggerException0?: Maybe<Scalars['Void']['output']>;
  triggerException1?: Maybe<Scalars['Void']['output']>;
  triggerException2?: Maybe<Scalars['Void']['output']>;
  triggerException3?: Maybe<Scalars['Void']['output']>;
  triggerException4?: Maybe<Scalars['Void']['output']>;
  user: UserType;
};


export type QueryAllAnnouncementsArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryAutofixRunMermaidArgs = {
  runId: Scalars['ID']['input'];
};


export type QueryAutoinstallRunMermaidArgs = {
  endNode: Scalars['ID']['input'];
  runId: Scalars['ID']['input'];
  startNode: Scalars['ID']['input'];
};


export type QueryCaptureSettingsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCaptureSettingsFromApiKeyArgs = {
  apiKey: Scalars['String']['input'];
};


export type QueryCompanyArgs = {
  apiKey: Scalars['UUID']['input'];
};


export type QueryDiffPrsBetweenMainAndProdArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  installationId: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
};


export type QueryFetchSessionLogsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  pageVisitUuids: Array<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};


export type QueryGetActiveGithubIntegrationForOwnerArgs = {
  apiKey: Scalars['String']['input'];
  owner: Scalars['String']['input'];
};


export type QueryGetAutocompleteDataForFieldArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  currentSearchDataForField: Scalars['String']['input'];
  field: Scalars['String']['input'];
  itemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  searchEntity: Scalars['String']['input'];
  topN?: Scalars['Int']['input'];
};


export type QueryGetAutofixRunStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetChecksForPullRequestArgs = {
  installationId: Scalars['String']['input'];
  pullRequestIdentifier: Scalars['String']['input'];
  repo: Scalars['String']['input'];
};


export type QueryGetEngineeringTicketArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  ticketId: Scalars['Int']['input'];
};


export type QueryGetEngineeringTicketPlatformIntegrationArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  provider: Scalars['String']['input'];
};


export type QueryGetEngineeringTicketPlatformIntegrationConfigsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetEngineeringTicketPlatformIntegrationsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetEngineeringTicketsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  provider: Scalars['String']['input'];
};


export type QueryGetExceptionRecordArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
};


export type QueryGetExceptionRecordFromApiKeyAndIdArgs = {
  apiKey: Scalars['String']['input'];
  issueId: Scalars['Int']['input'];
};


export type QueryGetFieldValuesArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  fieldName: Scalars['String']['input'];
  searchEntity: Scalars['String']['input'];
};


export type QueryGetFullAutocompleteDataArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  itemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  searchEntity: Scalars['String']['input'];
  topN?: Scalars['Int']['input'];
};


export type QueryGetGithubIntegrationsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetGroupedRecordingSessionsForUserArgs = {
  companyId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetIssueArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  issueId: Scalars['Int']['input'];
};


export type QueryGetIssueFromIssueIdAndApiKeyArgs = {
  apiKey: Scalars['String']['input'];
  issueId: Scalars['Int']['input'];
};


export type QueryGetMessagingPlatformIntegrationsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetModifiedOrAddedFilesForPullRequestArgs = {
  installationId: Scalars['String']['input'];
  pullRequestIdentifier: Scalars['String']['input'];
  repo: Scalars['String']['input'];
};


export type QueryGetNetworkRequestStatusesForRecordingSessionArgs = {
  input: RecordingSessionNetworkRequestsInput;
};


export type QueryGetNotificationSettingsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRepoDefaultTargetBranchArgs = {
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
};


export type QueryGetSessionIdsAndTimeWindowsForIssueArgs = {
  issueId: Scalars['Int']['input'];
};


export type QueryGetTriageArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  triageId: Scalars['Int']['input'];
};


export type QueryJsSnippetConfigParametersArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListSlackChannelsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecordingSessionArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  pageId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchUsingQueryArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: Scalars['String']['input'];
  searchEntity: Scalars['String']['input'];
  searchQuery: Scalars['String']['input'];
};


export type QuerySessionDetailsForKafkaFromApiKeyArgs = {
  apiKey: Scalars['String']['input'];
};


export type QuerySessionDetailsForKafkaFromSessionIdArgs = {
  sessionId: Scalars['String']['input'];
};


export type QuerySiteSettingsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySplitNonsessionApplogsBySecondsForApiKeyArgs = {
  apiKey: Scalars['String']['input'];
};


export type QueryStatusItemsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTriggerException0Args = {
  id: Scalars['String']['input'];
};


export type QueryTriggerException1Args = {
  id: Scalars['String']['input'];
};


export type QueryTriggerException2Args = {
  id: Scalars['String']['input'];
};


export type QueryTriggerException3Args = {
  id: Scalars['String']['input'];
};


export type QueryTriggerException4Args = {
  id: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};

export type RecordingEvents = {
  __typename?: 'RecordingEvents';
  events: Array<Scalars['JSON']['output']>;
  fileProcessingStats: FileProcessingStats;
  pageVisitUuid: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type RecordingMetadata = {
  __typename?: 'RecordingMetadata';
  device: DeviceMetadata;
  language: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  user: Scalars['String']['output'];
};

export type RecordingSessionEvents = {
  __typename?: 'RecordingSessionEvents';
  id: Scalars['ID']['output'];
  /** Recording Metadata */
  metadata?: Maybe<RecordingMetadata>;
  pageId?: Maybe<Scalars['String']['output']>;
  /** Unzipped events content */
  unzippedEvents: Array<RecordingEvents>;
  /** User interactions */
  userInteractions: InteractionsTaken;
};

export type RecordingSessionNetworkRequestsInput = {
  apiKey: Scalars['String']['input'];
  endTimestamp: Scalars['BigInt']['input'];
  sessionId: Scalars['String']['input'];
  startTimestamp: Scalars['BigInt']['input'];
};

export type RecordingSessionQueryResultsGroupedType = {
  __typename?: 'RecordingSessionQueryResultsGroupedType';
  recordings: Array<RecordingSessionType>;
  userId: Scalars['String']['output'];
  userInteractions?: Maybe<DeviceSplitInteractions>;
};

export type RecordingSessionQueryResultsGroupedTypePaginationWindow = {
  __typename?: 'RecordingSessionQueryResultsGroupedTypePaginationWindow';
  /** The list of items in this pagination window. */
  items: Array<RecordingSessionQueryResultsGroupedType>;
  /** Total number of items in the filtered dataset. */
  totalItemsCount: Scalars['Int']['output'];
};

export type RecordingSessionQueryResultsType = {
  __typename?: 'RecordingSessionQueryResultsType';
  queryType: Scalars['String']['output'];
  results: RecordingSessionQueryResultsGroupedTypePaginationWindow;
  tree: Scalars['String']['output'];
};

export type RecordingSessionQueryResultsTypeIssueQueryResultsTypeTriageQueryResultsTypeExceptionRecordQueryResultsTypeBigQueryResultsTypeNewRecordingSessionQueryResultsType = BigQueryResultsType | ExceptionRecordQueryResultsType | IssueQueryResultsType | NewRecordingSessionQueryResultsType | RecordingSessionQueryResultsType | TriageQueryResultsType;

export type RecordingSessionType = {
  __typename?: 'RecordingSessionType';
  dataIgnoredDueToDomainExclusion: Scalars['Boolean']['output'];
  deviceInfo?: Maybe<Scalars['JSON']['output']>;
  /** Duration in milliseconds [ms] */
  durationMs?: Maybe<Scalars['BigInt']['output']>;
  embeddingGenerationTask?: Maybe<DjangoModelType>;
  embeddingsCompleted?: Maybe<Scalars['Boolean']['output']>;
  eventsProcessed?: Maybe<Scalars['JSON']['output']>;
  eventsSeen?: Maybe<Scalars['JSON']['output']>;
  /** Human-readable start timestamp */
  formattedStartTimestamp: Scalars['String']['output'];
  hasValidEventsProcessed: Scalars['Boolean']['output'];
  hasValidEventsSeen: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isShadow: Scalars['Boolean']['output'];
  isZipped: Scalars['Boolean']['output'];
  /** Recording Metadata */
  metadata?: Maybe<RecordingMetadata>;
  numberOfEventsProcessed: Scalars['Int']['output'];
  numberOfEventsSeen: Scalars['Int']['output'];
  /** Page navigations */
  pageNavigations: Array<PageNavigationInteraction>;
  /** Page visits */
  pageVisits: Array<PageVisitType>;
  revision: Scalars['Int']['output'];
  rootDomain?: Maybe<DjangoModelType>;
  serviceIdentifier?: Maybe<DjangoModelType>;
  shadowSessionId?: Maybe<Scalars['String']['output']>;
  startTimestamp: Scalars['BigInt']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  traits?: Maybe<Scalars['JSON']['output']>;
  /** Count of linked user actions */
  userActionsCount: Scalars['Int']['output'];
  userDeviceUuid?: Maybe<Scalars['UUID']['output']>;
  userId: Scalars['String']['output'];
  userIdHasBeenSet: Scalars['Boolean']['output'];
  /** User interactions */
  userInteractions: InteractionsTaken;
};

export type RecordingSessionUserActionInput = {
  actionType: Scalars['String']['input'];
  dotPath?: InputMaybe<Scalars['String']['input']>;
  recordingSessionId: Scalars['String']['input'];
  textContent?: InputMaybe<Scalars['String']['input']>;
  timestamp: Scalars['DateTime']['input'];
};

export type RecordingSessionUserActionType = {
  __typename?: 'RecordingSessionUserActionType';
  actionType: Scalars['String']['output'];
  dotPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  recordingSessionId: Scalars['String']['output'];
  textContent?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type RecordingTriageTimeWindow = {
  timestampEnd: Scalars['Int']['input'];
  timestampStart: Scalars['Int']['input'];
};

export type RecordingTriageTimeWindowType = {
  __typename?: 'RecordingTriageTimeWindowType';
  timestampEnd: Scalars['BigInt']['output'];
  timestampStart: Scalars['BigInt']['output'];
};

export type ResolveIssueInput = {
  issueId: Scalars['Int']['input'];
  setResolvedStateTo: Scalars['Boolean']['input'];
};

export type ResourceInput = {
  name: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
  otherMetadata?: InputMaybe<Scalars['JSON']['input']>;
  resourceType: Scalars['String']['input'];
  resourceUuid: Scalars['String']['input'];
  spec: Scalars['JSON']['input'];
};

export type SegmentDataType = {
  __typename?: 'SegmentDataType';
  endTimestamp: Scalars['BigInt']['output'];
  startTimestamp: Scalars['BigInt']['output'];
  userDeviceUuid: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SegmentInput = {
  endTimestamp: Scalars['BigInt']['input'];
  startTimestamp: Scalars['BigInt']['input'];
  userDeviceUuid: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ServiceIdentifierType = {
  __typename?: 'ServiceIdentifierType';
  additionalMetadata?: Maybe<Scalars['JSON']['output']>;
  company: DjangoModelType;
  firstSeen: Scalars['DateTime']['output'];
  gitSha?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  identifierModified: Scalars['Boolean']['output'];
  infrastructureDetails?: Maybe<DjangoModelType>;
  lastUpdated: Scalars['DateTime']['output'];
  mapUuid?: Maybe<Scalars['UUID']['output']>;
  recorder: DjangoModelType;
  setupInterceptorsLocation?: Maybe<DjangoModelType>;
  timeFirstReported?: Maybe<Scalars['Int']['output']>;
  timeLastUpdateReported?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SessionDetailsForKafka = {
  __typename?: 'SessionDetailsForKafka';
  bucketName: Scalars['String']['output'];
  datasetId?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isZipped: Scalars['Boolean']['output'];
  splitNonsessionApplogsBySeconds: Scalars['Int']['output'];
};

export type SessionIdsAndTimeWindows = {
  __typename?: 'SessionIdsAndTimeWindows';
  sessionIds: Array<Scalars['String']['output']>;
  timeWindow: RecordingTriageTimeWindowType;
};

export type SessionItemType = {
  __typename?: 'SessionItemType';
  deviceInfo?: Maybe<DeviceMetadata>;
  durationMs?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['String']['output'];
  startTimestamp?: Maybe<Scalars['BigInt']['output']>;
  userInteractions: Array<Scalars['BigInt']['output']>;
};

export type SimilarityInput = {
  similarExceptionId: Scalars['String']['input'];
  similarityScore: Scalars['Float']['input'];
};

export type SiteSettingsInput = {
  backendApi?: InputMaybe<Scalars['String']['input']>;
  sailfishBackendApi?: InputMaybe<Scalars['String']['input']>;
};

export type SiteSettingsType = {
  __typename?: 'SiteSettingsType';
  /** API Key for use in application integrations */
  apiKey: Scalars['String']['output'];
  backendApi: Scalars['String']['output'];
  /** Is the Backend API URL the default, or modified */
  defaultBackendApiUrl: Scalars['String']['output'];
  /** Is the Backend API URL the default, or modified */
  defaultSailfishBackendApiUrl: Scalars['String']['output'];
  /** Is the Backend API URL the default, or modified */
  isDefaultBackendApiUrl: Scalars['Boolean']['output'];
  /** Is the Sailfish Backend API URL the default, or modified */
  isDefaultSailfishBackendApiUrl: Scalars['Boolean']['output'];
  sailfishBackendApi: Scalars['String']['output'];
};

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SlackIntegrationType = {
  __typename?: 'SlackIntegrationType';
  appId: Scalars['String']['output'];
  botUserId: Scalars['String']['output'];
  defaultEngineeringCollaborationChannel?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['String']['output'];
  teamName: Scalars['String']['output'];
};

export type SnoozeIssueInput = {
  issueId: Scalars['Int']['input'];
  snoozedMode?: InputMaybe<Scalars['String']['input']>;
  snoozedPermanently?: InputMaybe<Scalars['Boolean']['input']>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SnoozeIssueUpdateStatus = {
  __typename?: 'SnoozeIssueUpdateStatus';
  id: Scalars['ID']['output'];
  snoozedMode: Scalars['String']['output'];
  snoozedPermanently: Scalars['Boolean']['output'];
  snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type ToggleFollowIssueInput = {
  issueId: Scalars['Int']['input'];
  wantsToFollow: Scalars['Boolean']['input'];
};

export type TraceFrameType = {
  __typename?: 'TraceFrameType';
  code: Scalars['String']['output'];
  file: Scalars['String']['output'];
  function: Scalars['String']['output'];
  isInstalledPackage?: Maybe<Scalars['Boolean']['output']>;
  line: Scalars['String']['output'];
  locals?: Maybe<Scalars['JSON']['output']>;
  offender?: Maybe<Scalars['Boolean']['output']>;
};

export type TriageInputLogs = {
  logRecordIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recordingId: Scalars['String']['input'];
};

export type TriageInputRecording = {
  identifiedProblemWindows?: InputMaybe<Array<RecordingTriageTimeWindow>>;
  recordingId: Scalars['String']['input'];
};

export type TriageInputSegment = {
  endTimestamp: Scalars['BigInt']['input'];
  sessionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startTimestamp: Scalars['BigInt']['input'];
  userId: Scalars['String']['input'];
};

export type TriageIssueType = {
  __typename?: 'TriageIssueType';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TriageLogDataType = {
  __typename?: 'TriageLogDataType';
  recording: RecordingSessionType;
  triage: TriageType;
};

export type TriageQueryResultsType = {
  __typename?: 'TriageQueryResultsType';
  queryType: Scalars['String']['output'];
  results: TriageTypePaginationWindow;
  tree: Scalars['String']['output'];
};

export type TriageRecordingDataType = {
  __typename?: 'TriageRecordingDataType';
  recording: RecordingSessionType;
  timeWindows: Array<TriageTimeWindow>;
  triage: TriageType;
};

export type TriageSimilarRecordingType = {
  __typename?: 'TriageSimilarRecordingType';
  endTimestamp: Scalars['BigInt']['output'];
  recording: RecordingSessionType;
  startTimestamp: Scalars['BigInt']['output'];
};

export type TriageSimilarSegmentType = {
  __typename?: 'TriageSimilarSegmentType';
  endTimestamp: Scalars['BigInt']['output'];
  evaluationTime: Scalars['DateTime']['output'];
  /** Recordings associated with this similar segment */
  segments: Array<SegmentDataType>;
  startTimestamp: Scalars['BigInt']['output'];
  triage: TriageType;
  userDeviceUuid?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type TriageTimeWindow = {
  __typename?: 'TriageTimeWindow';
  timestampEnd: Scalars['Float']['output'];
  timestampStart: Scalars['Float']['output'];
};

export type TriageType = {
  __typename?: 'TriageType';
  /** Affected % (Sessions) */
  affectedPercentageSessions?: Maybe<Scalars['String']['output']>;
  /** Affected % (Users) */
  affectedPercentageUsers?: Maybe<Scalars['String']['output']>;
  /** Changes made in the last 24h */
  change24h?: Maybe<Scalars['String']['output']>;
  company: DjangoModelType;
  /** Created at */
  createdAt: Scalars['DateTime']['output'];
  /** Updated time, human-readable timestamp */
  createdAtFormatted: Scalars['String']['output'];
  /** Identifier of who created the record */
  createdBy: Scalars['String']['output'];
  createdBySystem?: Maybe<Scalars['String']['output']>;
  createdByUser?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  /** Devices */
  devices?: Maybe<Array<DeviceMetadata>>;
  endTimestamp?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  /** Triage is ready */
  isReady: Scalars['Boolean']['output'];
  /** List of issues related to the triage */
  issues: Array<TriageIssueType>;
  /** Last seen */
  lastSeen?: Maybe<Scalars['String']['output']>;
  /** Other similar recordings */
  otherSimilarRecordings: Array<TriageSimilarRecordingType>;
  queryEmbedderTask?: Maybe<DjangoModelType>;
  /** Severity */
  severity?: Maybe<Scalars['String']['output']>;
  /** Similar segments */
  similarSegments: Array<TriageSimilarSegmentType>;
  startTimestamp?: Maybe<Scalars['Int']['output']>;
  triageLogData: Array<TriageLogDataType>;
  triageRecordingData: Array<TriageRecordingDataType>;
  updatedAt: Scalars['DateTime']['output'];
  /** Created time, human-readable timestamp */
  updatedAtFormatted: Scalars['String']['output'];
  /** Identifier of who last updated the record */
  updatedBy: Scalars['String']['output'];
  userDeviceUuid?: Maybe<Scalars['UUID']['output']>;
  userId: Scalars['String']['output'];
};

export type TriageTypePaginationWindow = {
  __typename?: 'TriageTypePaginationWindow';
  /** The list of items in this pagination window. */
  items: Array<TriageType>;
  /** Total number of items in the filtered dataset. */
  totalItemsCount: Scalars['Int']['output'];
};

export type TypeAheadBooleanField = {
  __typename?: 'TypeAheadBooleanField';
  name: Scalars['String']['output'];
  topNValues: Array<Scalars['Boolean']['output']>;
  totalValues: Scalars['Int']['output'];
};

export type TypeAheadJsonField = {
  __typename?: 'TypeAheadJsonField';
  fields: Array<TypeAheadTextField>;
  name: Scalars['String']['output'];
};

export type TypeAheadNumericField = {
  __typename?: 'TypeAheadNumericField';
  name: Scalars['String']['output'];
  topNValues: Array<Scalars['Float']['output']>;
  totalValues: Scalars['Int']['output'];
};

export type TypeAheadTextField = {
  __typename?: 'TypeAheadTextField';
  name: Scalars['String']['output'];
  topNValues: Array<Scalars['String']['output']>;
  totalValues: Scalars['Int']['output'];
};

export type TypeAheadTimeField = {
  __typename?: 'TypeAheadTimeField';
  end?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  start?: Maybe<Scalars['String']['output']>;
  totalValues: Scalars['Int']['output'];
};

export type TypingInteraction = {
  __typename?: 'TypingInteraction';
  attributes: Scalars['JSON']['output'];
  children?: Maybe<Array<Scalars['String']['output']>>;
  details: Scalars['String']['output'];
  element: Scalars['JSON']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  recordingId: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UserActionInput = {
  actionType: Scalars['String']['input'];
  dotPath?: InputMaybe<Scalars['String']['input']>;
  textContent?: InputMaybe<Scalars['String']['input']>;
  timestamp: Scalars['DateTime']['input'];
};

export type UserInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UserType = {
  __typename?: 'UserType';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  username: Scalars['String']['output'];
};

export type ValidationErrorDetailType = {
  __typename?: 'ValidationErrorDetailType';
  error: Scalars['String']['output'];
  suggestion: Scalars['String']['output'];
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  errorDetails: Array<ValidationErrorDetailType>;
  isJson: Scalars['Boolean']['output'];
  isScql: Scalars['Boolean']['output'];
  treeString: Scalars['String']['output'];
};

export type WaitlistSignupInput = {
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
  workEmail: Scalars['String']['input'];
};

export type WebhookNotificationSettingsInput = {
  timeBetweenSuccessiveNotificationsPerIssue: Scalars['Duration']['input'];
};

export type WebhookNotificationSettingsType = {
  __typename?: 'WebhookNotificationSettingsType';
  timeBetweenSuccessiveNotificationsPerIssue: Scalars['Duration']['output'];
};

export type AuthenticateUserUsingAccessTokenMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;


export type AuthenticateUserUsingAccessTokenMutation = { __typename?: 'Mutation', authenticateUserUsingAccessToken: { __typename?: 'AuthResponse', message: string, token: string, userId: string, email: string, picture: string, name: string } };

export type LogoutUserMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutUserMutation = { __typename?: 'Mutation', logout: boolean };

export type GetFieldValuesQueryVariables = Exact<{
  fieldName: Scalars['String']['input'];
  searchEntity: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFieldValuesQuery = { __typename?: 'Query', getFieldValues: Array<string> };

export type GetFullAutocompleteDataQueryVariables = Exact<{
  searchEntity: Scalars['String']['input'];
  itemIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  topN: Scalars['Int']['input'];
}>;


export type GetFullAutocompleteDataQuery = { __typename?: 'Query', getFullAutocompleteData?: { __typename?: 'FullAutocompleteData', textFields: Array<{ __typename?: 'TypeAheadTextField', name: string, topNValues: Array<string>, totalValues: number }>, numericFields: Array<{ __typename?: 'TypeAheadNumericField', name: string, topNValues: Array<number>, totalValues: number }>, booleanFields: Array<{ __typename?: 'TypeAheadBooleanField', name: string, topNValues: Array<boolean>, totalValues: number }>, timeFields: Array<{ __typename?: 'TypeAheadTimeField', name: string, start?: string | null, end?: string | null, totalValues: number }>, jsonFields: Array<{ __typename?: 'TypeAheadJsonField', name: string, fields: Array<{ __typename?: 'TypeAheadTextField', name: string, topNValues: Array<string>, totalValues: number }> }>, allowedComparators: { __typename?: 'AllowedComparators', string: Array<string>, numeric: Array<string>, boolean: Array<string>, time: Array<string>, json: Array<string> } } | null };

export type SearchUsingQueryQueryVariables = Exact<{
  searchEntity: Scalars['String']['input'];
  searchQuery: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
}>;


export type SearchUsingQueryQuery = { __typename?: 'Query', searchUsingQuery?: { __typename?: 'BigQueryResultsType', queryType: string, tree: string, results: { __typename?: 'BigQueryVaryingStructurePaginationWindow', totalItemsCount: number, items: Array<{ __typename?: 'BigQueryVaryingStructure', data: any }> } } | { __typename?: 'ExceptionRecordQueryResultsType', queryType: string, tree: string, results: { __typename?: 'ExceptionRecordTypePaginationWindow', totalItemsCount: number, items: Array<{ __typename?: 'ExceptionRecordType', id: string, timestampMs: string }> } } | { __typename?: 'IssueQueryResultsType', queryType: string, tree: string, results: { __typename?: 'IssueTypePaginationWindow', totalItemsCount: number, items: Array<{ __typename?: 'IssueType', id: string, createdAt: any, createdBy: string, isResolved: boolean, lastSeen: any, snoozedMode: string, title?: string | null, description?: string | null, severity?: string | null, canAutofix: boolean, hasExceptionRecords: boolean, autofixRuns?: { __typename?: 'AutofixRunType', state: string } | null, createdByUser?: { __typename?: 'UserType', email: string, avatarUrl?: string | null } | null, engineeringTicket?: { __typename?: 'EngineeringTicketType', title?: string | null, platformLink?: string | null, provider: string } | null }> } } | { __typename?: 'NewRecordingSessionQueryResultsType', queryType: string, tree: string, results: { __typename?: 'NewRecordingSessionQueryResultsGroupedTypePaginationWindow', totalItemsCount: number, items: Array<{ __typename?: 'NewRecordingSessionQueryResultsGroupedType', userId: string, sessions: { __typename?: 'NewRecordingSessionType', sessionCount: number, latestActionTimestamp: any, id: number, sessionItems: Array<{ __typename?: 'SessionItemType', id: string, startTimestamp?: any | null, durationMs?: any | null, userInteractions: Array<any>, deviceInfo?: { __typename?: 'DeviceMetadata', isBot: boolean, isTelevision: boolean, isMobile: boolean, isDesktop: boolean, device?: { __typename?: 'DeviceDetails', brand?: string | null, model?: string | null, type?: string | null } | null, client?: { __typename?: 'ClientDetails', name?: string | null, type?: string | null, version?: string | null } | null, os?: { __typename?: 'OSDetails', name?: string | null, version?: string | null } | null } | null }> } }> } } | { __typename?: 'RecordingSessionQueryResultsType', queryType: string, tree: string, results: { __typename?: 'RecordingSessionQueryResultsGroupedTypePaginationWindow', totalItemsCount: number, items: Array<{ __typename?: 'RecordingSessionQueryResultsGroupedType', userId: string, recordings: Array<{ __typename?: 'RecordingSessionType', id: string, startTimestamp: any, durationMs?: any | null, userActionsCount: number, userInteractions: { __typename?: 'InteractionsTaken', clicks: Array<{ __typename?: 'ClickInteraction', timestamp?: string | null, type: string, element: any, textContent: string, children?: Array<string> | null, details: string }>, pageNavigations: Array<{ __typename?: 'PageNavigationInteraction', timestamp?: string | null, url: string, details: string }>, textEdits: Array<{ __typename?: 'TypingInteraction', timestamp?: string | null, element: any, attributes: any, title?: string | null, placeholder?: string | null, children?: Array<string> | null, details: string }> }, metadata?: { __typename?: 'RecordingMetadata', user: string, language: string, timeZone?: string | null, region?: string | null, device: { __typename?: 'DeviceMetadata', isBot: boolean, isTelevision: boolean, isMobile: boolean, isDesktop: boolean, device?: { __typename?: 'DeviceDetails', brand?: string | null, model?: string | null, type?: string | null } | null, client?: { __typename?: 'ClientDetails', name?: string | null, type?: string | null, version?: string | null } | null, os?: { __typename?: 'OSDetails', name?: string | null, version?: string | null } | null } } | null }> }> } } | { __typename?: 'TriageQueryResultsType', queryType: string, tree: string, results: { __typename?: 'TriageTypePaginationWindow', totalItemsCount: number, items: Array<{ __typename?: 'TriageType', id: string, createdAt: any, createdBy: string, createdBySystem?: string | null, severity?: string | null, lastSeenTriage?: string | null, createdByUser?: { __typename?: 'UserType', email: string, avatarUrl?: string | null } | null, issues: Array<{ __typename?: 'TriageIssueType', id: string, title: string }> }> } } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'UserType', id: string, username: string, email: string } };

export type GetLatestBannerAnnouncementQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestBannerAnnouncementQuery = { __typename?: 'Query', latestBannerAnnouncement?: { __typename?: 'AnnouncementType', id: string, content: string, createdAt: string, type: string } | null };

export type GetSectionAnnouncementsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type GetSectionAnnouncementsQuery = { __typename?: 'Query', allAnnouncements: { __typename?: 'PaginatedAnnouncements', page: number, pageSize: number, totalPages: number, totalItems: number, announcements: Array<{ __typename?: 'AnnouncementType', id: string, content: string, createdAt: string, type: string }> } };

export type DismissAnnouncementMutationVariables = Exact<{
  announcementId: Scalars['Int']['input'];
}>;


export type DismissAnnouncementMutation = { __typename?: 'Mutation', dismissAnnouncement: boolean };

export type CreateIssueMutationVariables = Exact<{
  input: CreateIssueInput;
  createEngineeringTicket?: InputMaybe<Scalars['Boolean']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateIssueMutation = { __typename?: 'Mutation', createIssue?: { __typename?: 'IssueType', id: string, createdBy: string, createdAtFormatted: string, updatedAtFormatted: string } | null };

export type CreateEngineeringTicketMutationVariables = Exact<{
  input: CreateEngineeringTicketInput;
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateEngineeringTicketMutation = { __typename?: 'Mutation', createEngineeringTicket?: { __typename?: 'EngineeringTicketType', id: string } | null };

export type UpdateIssueMutationVariables = Exact<{
  input: EditIssueInput;
  teamId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateIssueMutation = { __typename?: 'Mutation', updateIssue?: { __typename?: 'IssueType', id: string } | null };

export type GetIssueQueryVariables = Exact<{
  issueId: Scalars['Int']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetIssueQuery = { __typename?: 'Query', getIssue?: { __typename?: 'IssueType', id: string, title?: string | null, description?: string | null, canAutofix: boolean, createdAt: any, createdBy: string, hasExceptionRecords: boolean, updatedBy: string, snoozedMode: string, snoozedUntilFormatted?: string | null, snoozedPermanently: boolean, isResolved: boolean, affectedPercentageUsers?: string | null, change24h?: string | null, lastSeen: any, severity?: string | null, devices?: Array<{ __typename?: 'DeviceMetadata', isDesktop: boolean, isMobile: boolean, isBot: boolean, isTelevision: boolean, device?: { __typename?: 'DeviceDetails', type?: string | null, brand?: string | null } | null }> | null, engineeringTicket?: { __typename?: 'EngineeringTicketType', team?: string | null, project?: string | null, priority?: number | null, provider: string, status?: string | null, platformLink?: string | null } | null, followers: Array<{ __typename?: 'UserType', email: string }>, exceptions: Array<{ __typename?: 'ExceptionRecordType', id: string, timestampMs: string }>, triages: Array<{ __typename?: 'TriageType', affectedPercentageUsers?: string | null, change24h?: string | null, createdBy: string, lastSeen?: string | null, severity?: string | null, updatedBy: string, devices?: Array<{ __typename?: 'DeviceMetadata', isDesktop: boolean, isMobile: boolean, isBot: boolean, isTelevision: boolean, device?: { __typename?: 'DeviceDetails', type?: string | null, brand?: string | null } | null }> | null, triageRecordingData: Array<{ __typename?: 'TriageRecordingDataType', recording: { __typename?: 'RecordingSessionType', durationMs?: any | null, startTimestamp: any, id: string, userActionsCount: number, pageVisits: Array<{ __typename?: 'PageVisitType', id: any, activeFrom: string, activeUntil?: string | null }>, userInteractions: { __typename?: 'InteractionsTaken', clicks: Array<{ __typename?: 'ClickInteraction', timestamp?: string | null, type: string, element: any, textContent: string, children?: Array<string> | null, details: string, recordingId: string }>, pageNavigations: Array<{ __typename?: 'PageNavigationInteraction', timestamp?: string | null, url: string, details: string, recordingId: string }>, textEdits: Array<{ __typename?: 'TypingInteraction', timestamp?: string | null, element: any, attributes: any, title?: string | null, placeholder?: string | null, children?: Array<string> | null, details: string, recordingId: string }> }, metadata?: { __typename?: 'RecordingMetadata', user: string, language: string, timeZone?: string | null, region?: string | null, device: { __typename?: 'DeviceMetadata', isBot: boolean, isTelevision: boolean, isMobile: boolean, isDesktop: boolean, device?: { __typename?: 'DeviceDetails', brand?: string | null, model?: string | null, type?: string | null } | null, client?: { __typename?: 'ClientDetails', name?: string | null, type?: string | null, version?: string | null } | null, os?: { __typename?: 'OSDetails', name?: string | null, version?: string | null } | null } } | null }, timeWindows: Array<{ __typename?: 'TriageTimeWindow', timestampStart: number, timestampEnd: number }> }>, triageLogData: Array<{ __typename?: 'TriageLogDataType', recording: { __typename?: 'RecordingSessionType', durationMs?: any | null, startTimestamp: any, id: string, userActionsCount: number, pageVisits: Array<{ __typename?: 'PageVisitType', id: any, activeFrom: string, activeUntil?: string | null }>, userInteractions: { __typename?: 'InteractionsTaken', clicks: Array<{ __typename?: 'ClickInteraction', timestamp?: string | null, type: string, element: any, textContent: string, children?: Array<string> | null, details: string, recordingId: string }>, pageNavigations: Array<{ __typename?: 'PageNavigationInteraction', timestamp?: string | null, url: string, details: string, recordingId: string }>, textEdits: Array<{ __typename?: 'TypingInteraction', timestamp?: string | null, element: any, attributes: any, title?: string | null, placeholder?: string | null, children?: Array<string> | null, details: string, recordingId: string }> }, metadata?: { __typename?: 'RecordingMetadata', user: string, language: string, timeZone?: string | null, region?: string | null, device: { __typename?: 'DeviceMetadata', isBot: boolean, isTelevision: boolean, isMobile: boolean, isDesktop: boolean, device?: { __typename?: 'DeviceDetails', brand?: string | null, model?: string | null, type?: string | null } | null, client?: { __typename?: 'ClientDetails', name?: string | null, type?: string | null, version?: string | null } | null, os?: { __typename?: 'OSDetails', name?: string | null, version?: string | null } | null } } | null } }>, otherSimilarRecordings: Array<{ __typename?: 'TriageSimilarRecordingType', recording: { __typename?: 'RecordingSessionType', durationMs?: any | null, startTimestamp: any, id: string, userActionsCount: number, pageVisits: Array<{ __typename?: 'PageVisitType', id: any, activeFrom: string, activeUntil?: string | null }>, userInteractions: { __typename?: 'InteractionsTaken', clicks: Array<{ __typename?: 'ClickInteraction', timestamp?: string | null, type: string, element: any, textContent: string, children?: Array<string> | null, details: string, recordingId: string }>, pageNavigations: Array<{ __typename?: 'PageNavigationInteraction', timestamp?: string | null, url: string, details: string, recordingId: string }>, textEdits: Array<{ __typename?: 'TypingInteraction', timestamp?: string | null, element: any, attributes: any, title?: string | null, placeholder?: string | null, children?: Array<string> | null, details: string, recordingId: string }> }, metadata?: { __typename?: 'RecordingMetadata', user: string, language: string, timeZone?: string | null, region?: string | null, device: { __typename?: 'DeviceMetadata', isBot: boolean, isTelevision: boolean, isMobile: boolean, isDesktop: boolean, device?: { __typename?: 'DeviceDetails', brand?: string | null, model?: string | null, type?: string | null } | null, client?: { __typename?: 'ClientDetails', name?: string | null, type?: string | null, version?: string | null } | null, os?: { __typename?: 'OSDetails', name?: string | null, version?: string | null } | null } } | null } }> }> } | null };

export type GetExceptionRecordQueryVariables = Exact<{
  id: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetExceptionRecordQuery = { __typename?: 'Query', getExceptionRecord?: { __typename?: 'ExceptionRecordType', id: string, timestampMs: string, exceptionMessage?: string | null, file?: string | null, line?: number | null, function?: string | null, code?: string | null, wasCaught: boolean, serviceIdentifier: { __typename?: 'ServiceIdentifierType', id: any, identifier?: string | null }, traceStack: Array<{ __typename?: 'TraceFrameType', file: string, line: string, function: string, code: string, locals?: any | null, isInstalledPackage?: boolean | null }> } | null };

export type StartAutofixMutationVariables = Exact<{
  issueId: Scalars['Int']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StartAutofixMutation = { __typename?: 'Mutation', startAutofix?: string | null };

export type GetRecordingSessionUnzippedEventsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRecordingSessionUnzippedEventsQuery = { __typename?: 'Query', recordingSession?: { __typename?: 'RecordingSessionEvents', id: string, unzippedEvents: Array<{ __typename?: 'RecordingEvents', events: Array<any>, sessionId: string, pageVisitUuid: string, fileProcessingStats: { __typename?: 'FileProcessingStats', processingTimeMs: number, dataFileStats: { __typename?: 'DataFileStats', numberOfFiles: number, totalSizeKb: number } } }>, metadata?: { __typename?: 'RecordingMetadata', user: string, language: string, timeZone?: string | null, region?: string | null, device: { __typename?: 'DeviceMetadata', isBot: boolean, isTelevision: boolean, isMobile: boolean, isDesktop: boolean, device?: { __typename?: 'DeviceDetails', brand?: string | null, model?: string | null, type?: string | null } | null, client?: { __typename?: 'ClientDetails', name?: string | null, type?: string | null, version?: string | null } | null, os?: { __typename?: 'OSDetails', name?: string | null, version?: string | null } | null } } | null } | null };

export type GetGroupedRecordingSessionsForUserQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
}>;


export type GetGroupedRecordingSessionsForUserQuery = { __typename?: 'Query', getGroupedRecordingSessionsForUser: { __typename?: 'RecordingSessionQueryResultsGroupedType', userId: string, userInteractions?: { __typename?: 'DeviceSplitInteractions', desktop: { __typename?: 'InteractionsTaken', clicks: Array<{ __typename?: 'ClickInteraction', timestamp?: string | null, type: string, element: any, textContent: string, children?: Array<string> | null, details: string, recordingId: string }>, pageNavigations: Array<{ __typename?: 'PageNavigationInteraction', timestamp?: string | null, url: string, details: string, recordingId: string }>, textEdits: Array<{ __typename?: 'TypingInteraction', timestamp?: string | null, element: any, attributes: any, title?: string | null, placeholder?: string | null, children?: Array<string> | null, details: string, recordingId: string }> }, mobile: { __typename?: 'InteractionsTaken', clicks: Array<{ __typename?: 'ClickInteraction', timestamp?: string | null, type: string, element: any, textContent: string, children?: Array<string> | null, details: string, recordingId: string }>, pageNavigations: Array<{ __typename?: 'PageNavigationInteraction', timestamp?: string | null, url: string, details: string, recordingId: string }>, textEdits: Array<{ __typename?: 'TypingInteraction', timestamp?: string | null, element: any, attributes: any, title?: string | null, placeholder?: string | null, children?: Array<string> | null, details: string, recordingId: string }> } } | null, recordings: Array<{ __typename?: 'RecordingSessionType', id: string, startTimestamp: any, durationMs?: any | null, userActionsCount: number, pageVisits: Array<{ __typename?: 'PageVisitType', id: any, activeFrom: string, activeUntil?: string | null }>, metadata?: { __typename?: 'RecordingMetadata', user: string, language: string, timeZone?: string | null, region?: string | null, device: { __typename?: 'DeviceMetadata', isBot: boolean, isTelevision: boolean, isMobile: boolean, isDesktop: boolean, device?: { __typename?: 'DeviceDetails', brand?: string | null, model?: string | null, type?: string | null } | null, client?: { __typename?: 'ClientDetails', name?: string | null, type?: string | null, version?: string | null } | null, os?: { __typename?: 'OSDetails', name?: string | null, version?: string | null } | null } } | null }> } };

export type GetJsSnippetConfigParametersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetJsSnippetConfigParametersQuery = { __typename?: 'Query', jsSnippetConfigParameters?: { __typename?: 'JsSnippetConfigParametersType', backendApi: string, apiKey: string, scriptSource: string } | null };

export type GetSiteSettingsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSiteSettingsQuery = { __typename?: 'Query', siteSettings?: { __typename?: 'SiteSettingsType', apiKey: string, backendApi: string, sailfishBackendApi: string, defaultBackendApiUrl: string, defaultSailfishBackendApiUrl: string, isDefaultBackendApiUrl: boolean, isDefaultSailfishBackendApiUrl: boolean } | null };

export type UpdateSiteSettingsMutationVariables = Exact<{
  input: SiteSettingsInput;
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateSiteSettingsMutation = { __typename?: 'Mutation', updateSiteSettings?: { __typename?: 'SiteSettingsType', backendApi: string, sailfishBackendApi: string, isDefaultBackendApiUrl: boolean, isDefaultSailfishBackendApiUrl: boolean } | null };

export type GetCaptureSettingsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCaptureSettingsQuery = { __typename?: 'Query', captureSettings?: { __typename?: 'CaptureSettingsType', recordCanvas: boolean, recordCrossOriginIframes: boolean, collectFonts: boolean, inlineImages: boolean, sampling: any, recordPassword: boolean, recordRealName: boolean, recordCreditCardInfo: boolean, recordSsn: boolean, recordDob: boolean, canEdit: boolean, ignoreDomains: Array<string>, cssFromDomain?: string | null, cssToDomain?: string | null } | null };

export type UpdateCaptureSettingsMutationVariables = Exact<{
  input: CaptureSettingsInput;
}>;


export type UpdateCaptureSettingsMutation = { __typename?: 'Mutation', updateCaptureSettings?: { __typename?: 'CaptureSettingsType', recordCanvas: boolean, recordCrossOriginIframes: boolean, collectFonts: boolean, inlineImages: boolean, sampling: any, recordPassword: boolean, recordRealName: boolean, recordCreditCardInfo: boolean, recordSsn: boolean, recordDob: boolean, ignoreDomains: Array<string>, cssFromDomain?: string | null, cssToDomain?: string | null } | null };

export type GetStatusItemsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStatusItemsQuery = { __typename?: 'Query', statusItems?: { __typename?: 'IntegrationStatusType', integrations: Array<{ __typename?: 'IntegrationType', title: string, link: string, tooltipText: string, isWorking: boolean }> } | null };

export type GetNotificationSettingsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNotificationSettingsQuery = { __typename?: 'Query', getNotificationSettings: { __typename?: 'NotificationsSettingsType', emailNotificationSettings: { __typename?: 'EmailNotificationSettingsType', defaultRecipients: any, timeBetweenSuccessiveNotificationsPerIssue: any }, webhookNotificationSettings: { __typename?: 'WebhookNotificationSettingsType', timeBetweenSuccessiveNotificationsPerIssue: any }, notificationWebhooks: Array<{ __typename?: 'NotificationWebhookType', id: string, webhookDataType: string, destinationAddress: string, authentication?: any | null }> } };

export type UpdateNotificationSettingsMutationVariables = Exact<{
  emailInput?: InputMaybe<EmailNotificationSettingsInput>;
  webhookInput?: InputMaybe<WebhookNotificationSettingsInput>;
  webhooks?: InputMaybe<Array<NotificationWebhookInput> | NotificationWebhookInput>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateNotificationSettingsMutation = { __typename?: 'Mutation', updateNotificationSettings: boolean };

export type FollowIssueMutationVariables = Exact<{
  input: FollowIssueInput;
}>;


export type FollowIssueMutation = { __typename?: 'Mutation', followIssue: boolean };

export type UnfollowIssueMutationVariables = Exact<{
  input: FollowIssueInput;
}>;


export type UnfollowIssueMutation = { __typename?: 'Mutation', unfollowIssue: boolean };

export type ToggleIssueFollowingStatusForUserMutationVariables = Exact<{
  input: ToggleFollowIssueInput;
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ToggleIssueFollowingStatusForUserMutation = { __typename?: 'Mutation', toggleIssueFollowingStatusForUser: boolean };

export type ToggleIssueResolvedStatusMutationVariables = Exact<{
  input: ResolveIssueInput;
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ToggleIssueResolvedStatusMutation = { __typename?: 'Mutation', toggleIssueResolvedStatus: boolean };

export type SnoozeIssueMutationVariables = Exact<{
  input: SnoozeIssueInput;
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SnoozeIssueMutation = { __typename?: 'Mutation', snoozeIssue: { __typename?: 'SnoozeIssueUpdateStatus', id: string, snoozedMode: string, snoozedUntil?: any | null, snoozedPermanently: boolean } };

export type GetEngineeringTicketPlatformIntegrationConfigsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEngineeringTicketPlatformIntegrationConfigsQuery = { __typename?: 'Query', getEngineeringTicketPlatformIntegrationConfigs: Array<{ __typename?: 'EngineeringTicketPlatformIntegrationConfigType', clientId: string, provider: string }> };

export type GetEngineeringTicketPlatformIntegrationQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEngineeringTicketPlatformIntegrationQuery = { __typename?: 'Query', getEngineeringTicketPlatformIntegration?: { __typename?: 'EngineeringTicketPlatformIntegrationType', pushAutoIdentifiedIssues: boolean, clientId: string, defaultPriority?: number | null, defaultProject?: string | null, defaultTeam?: string | null, installed: boolean, projects: any, teams: any, workflowStates: any } | null };

export type GetEngineeringTicketPlatformIntegrationsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEngineeringTicketPlatformIntegrationsQuery = { __typename?: 'Query', getEngineeringTicketPlatformIntegrations: Array<{ __typename?: 'EngineeringTicketPlatformIntegrationType', pushAutoIdentifiedIssues: boolean, provider: string, clientId: string, defaultPriority?: number | null, defaultProject?: string | null, defaultTeam?: string | null, installed: boolean, projects: any, teams: any, workflowStates: any }> };

export type AddGitHubIntegrationMutationVariables = Exact<{
  installationId: Scalars['String']['input'];
  setupAction: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddGitHubIntegrationMutation = { __typename?: 'Mutation', addGithubIntegration: { __typename?: 'GitHubIntegrationType', accountType?: string | null, installedOnAccount?: string | null, installedOnAllRepositories: boolean, installedOnRepositories: any } };

export type GetGithubIntegrationsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetGithubIntegrationsQuery = { __typename?: 'Query', getGithubIntegrations: Array<{ __typename?: 'GitHubIntegrationType', accountType?: string | null, installationId?: string | null, installedOnAccount?: string | null, installedOnAllRepositories: boolean, installedOnRepositories: any }> };

export type CreateEngineeringTicketPlatformIntegrationMutationVariables = Exact<{
  input: CreateEngineeringTicketPlatformIntegrationInput;
  inputProvider: CreateEngineeringTicketPlatformIntegrationConfig;
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateEngineeringTicketPlatformIntegrationMutation = { __typename?: 'Mutation', createEngineeringTicketPlatformIntegration?: { __typename?: 'EngineeringTicketPlatformIntegrationType', pushAutoIdentifiedIssues: boolean, defaultPriority?: number | null, defaultProject?: string | null, defaultTeam?: string | null } | null };

export type UpdateEngineeringTicketPlatformIntegrationMutationVariables = Exact<{
  input: EditEngineeringTicketPlatformIntegrationInput;
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateEngineeringTicketPlatformIntegrationMutation = { __typename?: 'Mutation', updateEngineeringTicketPlatformIntegration?: { __typename?: 'EngineeringTicketPlatformIntegrationType', pushAutoIdentifiedIssues: boolean, defaultPriority?: number | null, defaultProject?: string | null, defaultTeam?: string | null } | null };

export type GetMessagingPlatformIntegrationsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMessagingPlatformIntegrationsQuery = { __typename?: 'Query', getMessagingPlatformIntegrations: Array<{ __typename?: 'MessagingPlatformIntegrationType', provider: string, slackIntegration?: { __typename?: 'SlackIntegrationType', appId: string, teamId: string, teamName: string, botUserId: string, defaultEngineeringCollaborationChannel?: string | null } | null }> };

export type CreateSlackIntegrationMutationVariables = Exact<{
  code: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateSlackIntegrationMutation = { __typename?: 'Mutation', createSlackIntegration: { __typename?: 'SlackIntegrationType', appId: string, teamId: string, teamName: string, botUserId: string, defaultEngineeringCollaborationChannel?: string | null } };

export type ListSlackChannelsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListSlackChannelsQuery = { __typename?: 'Query', listSlackChannels?: Array<{ __typename?: 'SlackChannel', id: string, name: string }> | null };

export type UpdateSlackIntegrationMutationVariables = Exact<{
  input: EditSlackIntegrationInput;
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateSlackIntegrationMutation = { __typename?: 'Mutation', updateSlackIntegration: boolean };

export type RecordingFragmentFragment = { __typename?: 'RecordingSessionType', durationMs?: any | null, startTimestamp: any, id: string, userActionsCount: number, pageVisits: Array<{ __typename?: 'PageVisitType', id: any, activeFrom: string, activeUntil?: string | null }>, userInteractions: { __typename?: 'InteractionsTaken', clicks: Array<{ __typename?: 'ClickInteraction', timestamp?: string | null, type: string, element: any, textContent: string, children?: Array<string> | null, details: string, recordingId: string }>, pageNavigations: Array<{ __typename?: 'PageNavigationInteraction', timestamp?: string | null, url: string, details: string, recordingId: string }>, textEdits: Array<{ __typename?: 'TypingInteraction', timestamp?: string | null, element: any, attributes: any, title?: string | null, placeholder?: string | null, children?: Array<string> | null, details: string, recordingId: string }> }, metadata?: { __typename?: 'RecordingMetadata', user: string, language: string, timeZone?: string | null, region?: string | null, device: { __typename?: 'DeviceMetadata', isBot: boolean, isTelevision: boolean, isMobile: boolean, isDesktop: boolean, device?: { __typename?: 'DeviceDetails', brand?: string | null, model?: string | null, type?: string | null } | null, client?: { __typename?: 'ClientDetails', name?: string | null, type?: string | null, version?: string | null } | null, os?: { __typename?: 'OSDetails', name?: string | null, version?: string | null } | null } } | null };

export type CreateTriageMutationVariables = Exact<{
  triageInfoRecordings?: InputMaybe<Array<TriageInputRecording> | TriageInputRecording>;
  triageInfoSegment?: InputMaybe<TriageInputSegment>;
  triageInfoLogs?: InputMaybe<Array<TriageInputLogs> | TriageInputLogs>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateTriageMutation = { __typename?: 'Mutation', createTriage?: { __typename?: 'TriageType', id: string, createdBy: string, updatedBy: string, createdAt: any, updatedAt: any } | null };

export type GetTriageQueryVariables = Exact<{
  triageId: Scalars['Int']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTriageQuery = { __typename?: 'Query', getTriage?: { __typename?: 'TriageType', isReady: boolean, description?: string | null, affectedPercentageUsers?: string | null, change24h?: string | null, createdBy: string, createdAt: any, lastSeen?: string | null, severity?: string | null, updatedBy: string, devices?: Array<{ __typename?: 'DeviceMetadata', isDesktop: boolean, isMobile: boolean, isBot: boolean, isTelevision: boolean, device?: { __typename?: 'DeviceDetails', type?: string | null, brand?: string | null } | null }> | null, triageRecordingData: Array<{ __typename?: 'TriageRecordingDataType', recording: { __typename?: 'RecordingSessionType', durationMs?: any | null, startTimestamp: any, id: string, userActionsCount: number, pageVisits: Array<{ __typename?: 'PageVisitType', id: any, activeFrom: string, activeUntil?: string | null }>, userInteractions: { __typename?: 'InteractionsTaken', clicks: Array<{ __typename?: 'ClickInteraction', timestamp?: string | null, type: string, element: any, textContent: string, children?: Array<string> | null, details: string, recordingId: string }>, pageNavigations: Array<{ __typename?: 'PageNavigationInteraction', timestamp?: string | null, url: string, details: string, recordingId: string }>, textEdits: Array<{ __typename?: 'TypingInteraction', timestamp?: string | null, element: any, attributes: any, title?: string | null, placeholder?: string | null, children?: Array<string> | null, details: string, recordingId: string }> }, metadata?: { __typename?: 'RecordingMetadata', user: string, language: string, timeZone?: string | null, region?: string | null, device: { __typename?: 'DeviceMetadata', isBot: boolean, isTelevision: boolean, isMobile: boolean, isDesktop: boolean, device?: { __typename?: 'DeviceDetails', brand?: string | null, model?: string | null, type?: string | null } | null, client?: { __typename?: 'ClientDetails', name?: string | null, type?: string | null, version?: string | null } | null, os?: { __typename?: 'OSDetails', name?: string | null, version?: string | null } | null } } | null }, timeWindows: Array<{ __typename?: 'TriageTimeWindow', timestampStart: number, timestampEnd: number }> }>, triageLogData: Array<{ __typename?: 'TriageLogDataType', recording: { __typename?: 'RecordingSessionType', durationMs?: any | null, startTimestamp: any, id: string, userActionsCount: number, pageVisits: Array<{ __typename?: 'PageVisitType', id: any, activeFrom: string, activeUntil?: string | null }>, userInteractions: { __typename?: 'InteractionsTaken', clicks: Array<{ __typename?: 'ClickInteraction', timestamp?: string | null, type: string, element: any, textContent: string, children?: Array<string> | null, details: string, recordingId: string }>, pageNavigations: Array<{ __typename?: 'PageNavigationInteraction', timestamp?: string | null, url: string, details: string, recordingId: string }>, textEdits: Array<{ __typename?: 'TypingInteraction', timestamp?: string | null, element: any, attributes: any, title?: string | null, placeholder?: string | null, children?: Array<string> | null, details: string, recordingId: string }> }, metadata?: { __typename?: 'RecordingMetadata', user: string, language: string, timeZone?: string | null, region?: string | null, device: { __typename?: 'DeviceMetadata', isBot: boolean, isTelevision: boolean, isMobile: boolean, isDesktop: boolean, device?: { __typename?: 'DeviceDetails', brand?: string | null, model?: string | null, type?: string | null } | null, client?: { __typename?: 'ClientDetails', name?: string | null, type?: string | null, version?: string | null } | null, os?: { __typename?: 'OSDetails', name?: string | null, version?: string | null } | null } } | null } }>, otherSimilarRecordings: Array<{ __typename?: 'TriageSimilarRecordingType', recording: { __typename?: 'RecordingSessionType', durationMs?: any | null, startTimestamp: any, id: string, userActionsCount: number, pageVisits: Array<{ __typename?: 'PageVisitType', id: any, activeFrom: string, activeUntil?: string | null }>, userInteractions: { __typename?: 'InteractionsTaken', clicks: Array<{ __typename?: 'ClickInteraction', timestamp?: string | null, type: string, element: any, textContent: string, children?: Array<string> | null, details: string, recordingId: string }>, pageNavigations: Array<{ __typename?: 'PageNavigationInteraction', timestamp?: string | null, url: string, details: string, recordingId: string }>, textEdits: Array<{ __typename?: 'TypingInteraction', timestamp?: string | null, element: any, attributes: any, title?: string | null, placeholder?: string | null, children?: Array<string> | null, details: string, recordingId: string }> }, metadata?: { __typename?: 'RecordingMetadata', user: string, language: string, timeZone?: string | null, region?: string | null, device: { __typename?: 'DeviceMetadata', isBot: boolean, isTelevision: boolean, isMobile: boolean, isDesktop: boolean, device?: { __typename?: 'DeviceDetails', brand?: string | null, model?: string | null, type?: string | null } | null, client?: { __typename?: 'ClientDetails', name?: string | null, type?: string | null, version?: string | null } | null, os?: { __typename?: 'OSDetails', name?: string | null, version?: string | null } | null } } | null } }> } | null };

export type FetchSessionLogsQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
  pageVisitUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchSessionLogsQuery = { __typename?: 'Query', fetchSessionLogs: Array<{ __typename?: 'NetworkRequestsAndLogsForPageVisitUuid', sessionId: string, pageVisitUuid: string, frontendConsoleLogs: { __typename?: 'FrontendConsoleLogs', logs: Array<any>, fileProcessingStats: { __typename?: 'FileProcessingStats', processingTimeMs: number, dataFileStats: { __typename?: 'DataFileStats', numberOfFiles: number, totalSizeKb: number } } }, networkRequestData: { __typename?: 'NetworkRequestDataCollective', networkRequestData: Array<{ __typename?: 'NetworkRequestDataIndividual', requestId: string, logs: Array<any>, printStatements: Array<any>, exceptions: Array<any>, fileProcessingStats: { __typename?: 'FileProcessingStats', processingTimeMs: number, dataFileStats: { __typename?: 'DataFileStats', numberOfFiles: number, totalSizeKb: number } } }>, fileProcessingStats: { __typename?: 'FileProcessingStats', processingTimeMs: number, dataFileStats: { __typename?: 'DataFileStats', numberOfFiles: number, totalSizeKb: number } } } }> };

export type GetFeatureRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeatureRequestsQuery = { __typename?: 'Query', featureRequests: Array<{ __typename?: 'FeatureRequestType', id: string, title: string, description: string, totalVotes: number, companiesVoted: Array<string>, dateRequested: any, lastUpdate: any, votedByUser: boolean }> };

export type SubmitFeatureRequestMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type SubmitFeatureRequestMutation = { __typename?: 'Mutation', submitFeatureRequest?: { __typename?: 'FeatureRequestType', id: string, title: string, description: string, totalVotes: number, companiesVoted: Array<string>, dateRequested: any, lastUpdate: any } | null };

export type ToggleVoteMutationVariables = Exact<{
  requestId: Scalars['ID']['input'];
}>;


export type ToggleVoteMutation = { __typename?: 'Mutation', toggleVote: { __typename?: 'FeatureRequestType', id: string, totalVotes: number, votedByUser: boolean } };

export const RecordingFragmentFragmentDoc = gql`
    fragment RecordingFragment on RecordingSessionType {
  durationMs
  startTimestamp
  id
  pageVisits {
    id
    activeFrom
    activeUntil
  }
  userActionsCount
  userInteractions {
    clicks {
      timestamp
      type
      element
      textContent
      children
      details
      recordingId
    }
    pageNavigations {
      timestamp
      url
      details
      recordingId
    }
    textEdits {
      timestamp
      element
      attributes
      title
      placeholder
      children
      details
      recordingId
    }
  }
  metadata {
    user
    device {
      isBot
      isTelevision
      isMobile
      isDesktop
      device {
        brand
        model
        type
      }
      client {
        name
        type
        version
      }
      os {
        name
        version
      }
    }
    language
    timeZone
    region
  }
}
    `;
export const AuthenticateUserUsingAccessTokenDocument = gql`
    mutation AuthenticateUserUsingAccessToken($accessToken: String!) {
  authenticateUserUsingAccessToken(accessToken: $accessToken) {
    message
    token
    userId
    email
    picture
    name
  }
}
    `;
export type AuthenticateUserUsingAccessTokenMutationFn = Apollo.MutationFunction<AuthenticateUserUsingAccessTokenMutation, AuthenticateUserUsingAccessTokenMutationVariables>;

/**
 * __useAuthenticateUserUsingAccessTokenMutation__
 *
 * To run a mutation, you first call `useAuthenticateUserUsingAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserUsingAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateUserUsingAccessTokenMutation, { data, loading, error }] = useAuthenticateUserUsingAccessTokenMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useAuthenticateUserUsingAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateUserUsingAccessTokenMutation, AuthenticateUserUsingAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateUserUsingAccessTokenMutation, AuthenticateUserUsingAccessTokenMutationVariables>(AuthenticateUserUsingAccessTokenDocument, options);
      }
export type AuthenticateUserUsingAccessTokenMutationHookResult = ReturnType<typeof useAuthenticateUserUsingAccessTokenMutation>;
export type AuthenticateUserUsingAccessTokenMutationResult = Apollo.MutationResult<AuthenticateUserUsingAccessTokenMutation>;
export type AuthenticateUserUsingAccessTokenMutationOptions = Apollo.BaseMutationOptions<AuthenticateUserUsingAccessTokenMutation, AuthenticateUserUsingAccessTokenMutationVariables>;
export const LogoutUserDocument = gql`
    mutation LogoutUser {
  logout
}
    `;
export type LogoutUserMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutUserMutation(baseOptions?: Apollo.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserDocument, options);
      }
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>;
export type LogoutUserMutationResult = Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>;
export const GetFieldValuesDocument = gql`
    query GetFieldValues($fieldName: String!, $searchEntity: String!, $companyId: Int) {
  getFieldValues(
    fieldName: $fieldName
    searchEntity: $searchEntity
    companyId: $companyId
  )
}
    `;

/**
 * __useGetFieldValuesQuery__
 *
 * To run a query within a React component, call `useGetFieldValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldValuesQuery({
 *   variables: {
 *      fieldName: // value for 'fieldName'
 *      searchEntity: // value for 'searchEntity'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetFieldValuesQuery(baseOptions: Apollo.QueryHookOptions<GetFieldValuesQuery, GetFieldValuesQueryVariables> & ({ variables: GetFieldValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFieldValuesQuery, GetFieldValuesQueryVariables>(GetFieldValuesDocument, options);
      }
export function useGetFieldValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFieldValuesQuery, GetFieldValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFieldValuesQuery, GetFieldValuesQueryVariables>(GetFieldValuesDocument, options);
        }
export function useGetFieldValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFieldValuesQuery, GetFieldValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFieldValuesQuery, GetFieldValuesQueryVariables>(GetFieldValuesDocument, options);
        }
export type GetFieldValuesQueryHookResult = ReturnType<typeof useGetFieldValuesQuery>;
export type GetFieldValuesLazyQueryHookResult = ReturnType<typeof useGetFieldValuesLazyQuery>;
export type GetFieldValuesSuspenseQueryHookResult = ReturnType<typeof useGetFieldValuesSuspenseQuery>;
export type GetFieldValuesQueryResult = Apollo.QueryResult<GetFieldValuesQuery, GetFieldValuesQueryVariables>;
export const GetFullAutocompleteDataDocument = gql`
    query getFullAutocompleteData($searchEntity: String!, $itemIds: [String!], $topN: Int!) {
  getFullAutocompleteData(
    searchEntity: $searchEntity
    itemIds: $itemIds
    topN: $topN
  ) {
    textFields {
      name
      topNValues
      totalValues
    }
    numericFields {
      name
      topNValues
      totalValues
    }
    booleanFields {
      name
      topNValues
      totalValues
    }
    timeFields {
      name
      start
      end
      totalValues
    }
    jsonFields {
      name
      fields {
        name
        topNValues
        totalValues
      }
    }
    allowedComparators {
      string
      numeric
      boolean
      time
      json
    }
  }
}
    `;

/**
 * __useGetFullAutocompleteDataQuery__
 *
 * To run a query within a React component, call `useGetFullAutocompleteDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullAutocompleteDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullAutocompleteDataQuery({
 *   variables: {
 *      searchEntity: // value for 'searchEntity'
 *      itemIds: // value for 'itemIds'
 *      topN: // value for 'topN'
 *   },
 * });
 */
export function useGetFullAutocompleteDataQuery(baseOptions: Apollo.QueryHookOptions<GetFullAutocompleteDataQuery, GetFullAutocompleteDataQueryVariables> & ({ variables: GetFullAutocompleteDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullAutocompleteDataQuery, GetFullAutocompleteDataQueryVariables>(GetFullAutocompleteDataDocument, options);
      }
export function useGetFullAutocompleteDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullAutocompleteDataQuery, GetFullAutocompleteDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullAutocompleteDataQuery, GetFullAutocompleteDataQueryVariables>(GetFullAutocompleteDataDocument, options);
        }
export function useGetFullAutocompleteDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFullAutocompleteDataQuery, GetFullAutocompleteDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFullAutocompleteDataQuery, GetFullAutocompleteDataQueryVariables>(GetFullAutocompleteDataDocument, options);
        }
export type GetFullAutocompleteDataQueryHookResult = ReturnType<typeof useGetFullAutocompleteDataQuery>;
export type GetFullAutocompleteDataLazyQueryHookResult = ReturnType<typeof useGetFullAutocompleteDataLazyQuery>;
export type GetFullAutocompleteDataSuspenseQueryHookResult = ReturnType<typeof useGetFullAutocompleteDataSuspenseQuery>;
export type GetFullAutocompleteDataQueryResult = Apollo.QueryResult<GetFullAutocompleteDataQuery, GetFullAutocompleteDataQueryVariables>;
export const SearchUsingQueryDocument = gql`
    query searchUsingQuery($searchEntity: String!, $searchQuery: String!, $limit: Int!, $offset: Int!, $orderBy: String, $companyId: Int!) {
  searchUsingQuery(
    searchEntity: $searchEntity
    searchQuery: $searchQuery
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    companyId: $companyId
  ) {
    ... on NewRecordingSessionQueryResultsType {
      results {
        items {
          userId
          sessions {
            sessionCount
            latestActionTimestamp
            id
            sessionItems {
              id
              startTimestamp
              durationMs
              userInteractions
              deviceInfo {
                isBot
                isTelevision
                isMobile
                isDesktop
                device {
                  brand
                  model
                  type
                }
                client {
                  name
                  type
                  version
                }
                os {
                  name
                  version
                }
              }
            }
          }
        }
        totalItemsCount
      }
      queryType
      tree
    }
    ... on RecordingSessionQueryResultsType {
      results {
        items {
          userId
          recordings {
            id
            startTimestamp
            durationMs
            userActionsCount
            userInteractions {
              clicks {
                timestamp
                type
                element
                textContent
                children
                details
              }
              pageNavigations {
                timestamp
                url
                details
              }
              textEdits {
                timestamp
                element
                attributes
                title
                placeholder
                children
                details
              }
            }
            metadata {
              user
              device {
                isBot
                isTelevision
                isMobile
                isDesktop
                device {
                  brand
                  model
                  type
                }
                client {
                  name
                  type
                  version
                }
                os {
                  name
                  version
                }
              }
              language
              timeZone
              region
            }
          }
        }
        totalItemsCount
      }
      queryType
      tree
    }
    ... on ExceptionRecordQueryResultsType {
      results {
        items {
          id
          timestampMs
        }
        totalItemsCount
      }
      queryType
      tree
    }
    ... on IssueQueryResultsType {
      results {
        items {
          id
          createdAt
          createdBy
          isResolved
          lastSeen
          snoozedMode
          title
          description
          severity
          canAutofix
          hasExceptionRecords
          autofixRuns {
            state
          }
          createdByUser {
            email
            avatarUrl
          }
          engineeringTicket {
            title
            platformLink
            provider
          }
        }
        totalItemsCount
      }
      queryType
      tree
    }
    ... on TriageQueryResultsType {
      results {
        items {
          id
          createdAt
          createdBy
          createdBySystem
          lastSeenTriage: lastSeen
          severity
          createdByUser {
            email
            avatarUrl
          }
          issues {
            id
            title
          }
        }
        totalItemsCount
      }
      queryType
      tree
    }
    ... on BigQueryResultsType {
      results {
        items {
          data
        }
        totalItemsCount
      }
      queryType
      tree
    }
  }
}
    `;

/**
 * __useSearchUsingQueryQuery__
 *
 * To run a query within a React component, call `useSearchUsingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsingQueryQuery({
 *   variables: {
 *      searchEntity: // value for 'searchEntity'
 *      searchQuery: // value for 'searchQuery'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSearchUsingQueryQuery(baseOptions: Apollo.QueryHookOptions<SearchUsingQueryQuery, SearchUsingQueryQueryVariables> & ({ variables: SearchUsingQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsingQueryQuery, SearchUsingQueryQueryVariables>(SearchUsingQueryDocument, options);
      }
export function useSearchUsingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsingQueryQuery, SearchUsingQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsingQueryQuery, SearchUsingQueryQueryVariables>(SearchUsingQueryDocument, options);
        }
export function useSearchUsingQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsingQueryQuery, SearchUsingQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsingQueryQuery, SearchUsingQueryQueryVariables>(SearchUsingQueryDocument, options);
        }
export type SearchUsingQueryQueryHookResult = ReturnType<typeof useSearchUsingQueryQuery>;
export type SearchUsingQueryLazyQueryHookResult = ReturnType<typeof useSearchUsingQueryLazyQuery>;
export type SearchUsingQuerySuspenseQueryHookResult = ReturnType<typeof useSearchUsingQuerySuspenseQuery>;
export type SearchUsingQueryQueryResult = Apollo.QueryResult<SearchUsingQueryQuery, SearchUsingQueryQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    username
    email
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const GetLatestBannerAnnouncementDocument = gql`
    query GetLatestBannerAnnouncement {
  latestBannerAnnouncement {
    id
    content
    createdAt
    type
  }
}
    `;

/**
 * __useGetLatestBannerAnnouncementQuery__
 *
 * To run a query within a React component, call `useGetLatestBannerAnnouncementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestBannerAnnouncementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestBannerAnnouncementQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestBannerAnnouncementQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestBannerAnnouncementQuery, GetLatestBannerAnnouncementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestBannerAnnouncementQuery, GetLatestBannerAnnouncementQueryVariables>(GetLatestBannerAnnouncementDocument, options);
      }
export function useGetLatestBannerAnnouncementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestBannerAnnouncementQuery, GetLatestBannerAnnouncementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestBannerAnnouncementQuery, GetLatestBannerAnnouncementQueryVariables>(GetLatestBannerAnnouncementDocument, options);
        }
export function useGetLatestBannerAnnouncementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestBannerAnnouncementQuery, GetLatestBannerAnnouncementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestBannerAnnouncementQuery, GetLatestBannerAnnouncementQueryVariables>(GetLatestBannerAnnouncementDocument, options);
        }
export type GetLatestBannerAnnouncementQueryHookResult = ReturnType<typeof useGetLatestBannerAnnouncementQuery>;
export type GetLatestBannerAnnouncementLazyQueryHookResult = ReturnType<typeof useGetLatestBannerAnnouncementLazyQuery>;
export type GetLatestBannerAnnouncementSuspenseQueryHookResult = ReturnType<typeof useGetLatestBannerAnnouncementSuspenseQuery>;
export type GetLatestBannerAnnouncementQueryResult = Apollo.QueryResult<GetLatestBannerAnnouncementQuery, GetLatestBannerAnnouncementQueryVariables>;
export const GetSectionAnnouncementsDocument = gql`
    query GetSectionAnnouncements($page: Int!, $pageSize: Int!) {
  allAnnouncements(page: $page, pageSize: $pageSize) {
    announcements {
      id
      content
      createdAt
      type
    }
    page
    pageSize
    totalPages
    totalItems
  }
}
    `;

/**
 * __useGetSectionAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetSectionAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionAnnouncementsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetSectionAnnouncementsQuery(baseOptions: Apollo.QueryHookOptions<GetSectionAnnouncementsQuery, GetSectionAnnouncementsQueryVariables> & ({ variables: GetSectionAnnouncementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSectionAnnouncementsQuery, GetSectionAnnouncementsQueryVariables>(GetSectionAnnouncementsDocument, options);
      }
export function useGetSectionAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSectionAnnouncementsQuery, GetSectionAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSectionAnnouncementsQuery, GetSectionAnnouncementsQueryVariables>(GetSectionAnnouncementsDocument, options);
        }
export function useGetSectionAnnouncementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSectionAnnouncementsQuery, GetSectionAnnouncementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSectionAnnouncementsQuery, GetSectionAnnouncementsQueryVariables>(GetSectionAnnouncementsDocument, options);
        }
export type GetSectionAnnouncementsQueryHookResult = ReturnType<typeof useGetSectionAnnouncementsQuery>;
export type GetSectionAnnouncementsLazyQueryHookResult = ReturnType<typeof useGetSectionAnnouncementsLazyQuery>;
export type GetSectionAnnouncementsSuspenseQueryHookResult = ReturnType<typeof useGetSectionAnnouncementsSuspenseQuery>;
export type GetSectionAnnouncementsQueryResult = Apollo.QueryResult<GetSectionAnnouncementsQuery, GetSectionAnnouncementsQueryVariables>;
export const DismissAnnouncementDocument = gql`
    mutation DismissAnnouncement($announcementId: Int!) {
  dismissAnnouncement(announcementId: $announcementId)
}
    `;
export type DismissAnnouncementMutationFn = Apollo.MutationFunction<DismissAnnouncementMutation, DismissAnnouncementMutationVariables>;

/**
 * __useDismissAnnouncementMutation__
 *
 * To run a mutation, you first call `useDismissAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissAnnouncementMutation, { data, loading, error }] = useDismissAnnouncementMutation({
 *   variables: {
 *      announcementId: // value for 'announcementId'
 *   },
 * });
 */
export function useDismissAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<DismissAnnouncementMutation, DismissAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissAnnouncementMutation, DismissAnnouncementMutationVariables>(DismissAnnouncementDocument, options);
      }
export type DismissAnnouncementMutationHookResult = ReturnType<typeof useDismissAnnouncementMutation>;
export type DismissAnnouncementMutationResult = Apollo.MutationResult<DismissAnnouncementMutation>;
export type DismissAnnouncementMutationOptions = Apollo.BaseMutationOptions<DismissAnnouncementMutation, DismissAnnouncementMutationVariables>;
export const CreateIssueDocument = gql`
    mutation CreateIssue($input: CreateIssueInput!, $createEngineeringTicket: Boolean, $teamId: String, $projectId: String, $priority: Int, $companyId: Int) {
  createIssue(
    input: $input
    createEngineeringTicket: $createEngineeringTicket
    teamId: $teamId
    projectId: $projectId
    priority: $priority
    companyId: $companyId
  ) {
    id
    createdBy
    createdAtFormatted
    updatedAtFormatted
  }
}
    `;
export type CreateIssueMutationFn = Apollo.MutationFunction<CreateIssueMutation, CreateIssueMutationVariables>;

/**
 * __useCreateIssueMutation__
 *
 * To run a mutation, you first call `useCreateIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIssueMutation, { data, loading, error }] = useCreateIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *      createEngineeringTicket: // value for 'createEngineeringTicket'
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      priority: // value for 'priority'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCreateIssueMutation(baseOptions?: Apollo.MutationHookOptions<CreateIssueMutation, CreateIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIssueMutation, CreateIssueMutationVariables>(CreateIssueDocument, options);
      }
export type CreateIssueMutationHookResult = ReturnType<typeof useCreateIssueMutation>;
export type CreateIssueMutationResult = Apollo.MutationResult<CreateIssueMutation>;
export type CreateIssueMutationOptions = Apollo.BaseMutationOptions<CreateIssueMutation, CreateIssueMutationVariables>;
export const CreateEngineeringTicketDocument = gql`
    mutation CreateEngineeringTicket($input: CreateEngineeringTicketInput!, $companyId: Int) {
  createEngineeringTicket(input: $input, companyId: $companyId) {
    id
  }
}
    `;
export type CreateEngineeringTicketMutationFn = Apollo.MutationFunction<CreateEngineeringTicketMutation, CreateEngineeringTicketMutationVariables>;

/**
 * __useCreateEngineeringTicketMutation__
 *
 * To run a mutation, you first call `useCreateEngineeringTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEngineeringTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEngineeringTicketMutation, { data, loading, error }] = useCreateEngineeringTicketMutation({
 *   variables: {
 *      input: // value for 'input'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCreateEngineeringTicketMutation(baseOptions?: Apollo.MutationHookOptions<CreateEngineeringTicketMutation, CreateEngineeringTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEngineeringTicketMutation, CreateEngineeringTicketMutationVariables>(CreateEngineeringTicketDocument, options);
      }
export type CreateEngineeringTicketMutationHookResult = ReturnType<typeof useCreateEngineeringTicketMutation>;
export type CreateEngineeringTicketMutationResult = Apollo.MutationResult<CreateEngineeringTicketMutation>;
export type CreateEngineeringTicketMutationOptions = Apollo.BaseMutationOptions<CreateEngineeringTicketMutation, CreateEngineeringTicketMutationVariables>;
export const UpdateIssueDocument = gql`
    mutation UpdateIssue($input: EditIssueInput!, $teamId: String, $projectId: String, $priority: Int, $companyId: Int, $status: String) {
  updateIssue(
    input: $input
    teamId: $teamId
    status: $status
    projectId: $projectId
    priority: $priority
    companyId: $companyId
  ) {
    id
  }
}
    `;
export type UpdateIssueMutationFn = Apollo.MutationFunction<UpdateIssueMutation, UpdateIssueMutationVariables>;

/**
 * __useUpdateIssueMutation__
 *
 * To run a mutation, you first call `useUpdateIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIssueMutation, { data, loading, error }] = useUpdateIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      priority: // value for 'priority'
 *      companyId: // value for 'companyId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateIssueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIssueMutation, UpdateIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIssueMutation, UpdateIssueMutationVariables>(UpdateIssueDocument, options);
      }
export type UpdateIssueMutationHookResult = ReturnType<typeof useUpdateIssueMutation>;
export type UpdateIssueMutationResult = Apollo.MutationResult<UpdateIssueMutation>;
export type UpdateIssueMutationOptions = Apollo.BaseMutationOptions<UpdateIssueMutation, UpdateIssueMutationVariables>;
export const GetIssueDocument = gql`
    query GetIssue($issueId: Int!, $companyId: Int) {
  getIssue(issueId: $issueId, companyId: $companyId) {
    id
    title
    description
    canAutofix
    createdAt
    createdBy
    hasExceptionRecords
    updatedBy
    snoozedMode
    snoozedUntilFormatted
    snoozedPermanently
    isResolved
    affectedPercentageUsers
    change24h
    devices {
      isDesktop
      isMobile
      isBot
      isTelevision
      device {
        type
        brand
      }
    }
    lastSeen
    severity
    engineeringTicket {
      team
      project
      priority
      provider
      status
      platformLink
    }
    followers {
      email
    }
    exceptions {
      id
      timestampMs
    }
    triages {
      affectedPercentageUsers
      change24h
      createdBy
      devices {
        isDesktop
        isMobile
        isBot
        isTelevision
        device {
          type
          brand
        }
      }
      lastSeen
      severity
      triageRecordingData {
        recording {
          ...RecordingFragment
        }
        timeWindows {
          timestampStart
          timestampEnd
        }
      }
      triageLogData {
        recording {
          ...RecordingFragment
        }
      }
      otherSimilarRecordings {
        recording {
          ...RecordingFragment
        }
      }
      updatedBy
    }
  }
}
    ${RecordingFragmentFragmentDoc}`;

/**
 * __useGetIssueQuery__
 *
 * To run a query within a React component, call `useGetIssueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssueQuery({
 *   variables: {
 *      issueId: // value for 'issueId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetIssueQuery(baseOptions: Apollo.QueryHookOptions<GetIssueQuery, GetIssueQueryVariables> & ({ variables: GetIssueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIssueQuery, GetIssueQueryVariables>(GetIssueDocument, options);
      }
export function useGetIssueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIssueQuery, GetIssueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIssueQuery, GetIssueQueryVariables>(GetIssueDocument, options);
        }
export function useGetIssueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIssueQuery, GetIssueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIssueQuery, GetIssueQueryVariables>(GetIssueDocument, options);
        }
export type GetIssueQueryHookResult = ReturnType<typeof useGetIssueQuery>;
export type GetIssueLazyQueryHookResult = ReturnType<typeof useGetIssueLazyQuery>;
export type GetIssueSuspenseQueryHookResult = ReturnType<typeof useGetIssueSuspenseQuery>;
export type GetIssueQueryResult = Apollo.QueryResult<GetIssueQuery, GetIssueQueryVariables>;
export const GetExceptionRecordDocument = gql`
    query GetExceptionRecord($id: String!, $companyId: Int) {
  getExceptionRecord(id: $id, companyId: $companyId) {
    id
    timestampMs
    exceptionMessage
    file
    line
    function
    code
    wasCaught
    serviceIdentifier {
      id
      identifier
    }
    traceStack {
      file
      line
      function
      code
      locals
      isInstalledPackage
    }
  }
}
    `;

/**
 * __useGetExceptionRecordQuery__
 *
 * To run a query within a React component, call `useGetExceptionRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExceptionRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExceptionRecordQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetExceptionRecordQuery(baseOptions: Apollo.QueryHookOptions<GetExceptionRecordQuery, GetExceptionRecordQueryVariables> & ({ variables: GetExceptionRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExceptionRecordQuery, GetExceptionRecordQueryVariables>(GetExceptionRecordDocument, options);
      }
export function useGetExceptionRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExceptionRecordQuery, GetExceptionRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExceptionRecordQuery, GetExceptionRecordQueryVariables>(GetExceptionRecordDocument, options);
        }
export function useGetExceptionRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExceptionRecordQuery, GetExceptionRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExceptionRecordQuery, GetExceptionRecordQueryVariables>(GetExceptionRecordDocument, options);
        }
export type GetExceptionRecordQueryHookResult = ReturnType<typeof useGetExceptionRecordQuery>;
export type GetExceptionRecordLazyQueryHookResult = ReturnType<typeof useGetExceptionRecordLazyQuery>;
export type GetExceptionRecordSuspenseQueryHookResult = ReturnType<typeof useGetExceptionRecordSuspenseQuery>;
export type GetExceptionRecordQueryResult = Apollo.QueryResult<GetExceptionRecordQuery, GetExceptionRecordQueryVariables>;
export const StartAutofixDocument = gql`
    mutation StartAutofix($issueId: Int!, $companyId: Int) {
  startAutofix(issueId: $issueId, companyId: $companyId)
}
    `;
export type StartAutofixMutationFn = Apollo.MutationFunction<StartAutofixMutation, StartAutofixMutationVariables>;

/**
 * __useStartAutofixMutation__
 *
 * To run a mutation, you first call `useStartAutofixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAutofixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAutofixMutation, { data, loading, error }] = useStartAutofixMutation({
 *   variables: {
 *      issueId: // value for 'issueId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useStartAutofixMutation(baseOptions?: Apollo.MutationHookOptions<StartAutofixMutation, StartAutofixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAutofixMutation, StartAutofixMutationVariables>(StartAutofixDocument, options);
      }
export type StartAutofixMutationHookResult = ReturnType<typeof useStartAutofixMutation>;
export type StartAutofixMutationResult = Apollo.MutationResult<StartAutofixMutation>;
export type StartAutofixMutationOptions = Apollo.BaseMutationOptions<StartAutofixMutation, StartAutofixMutationVariables>;
export const GetRecordingSessionUnzippedEventsDocument = gql`
    query GetRecordingSessionUnzippedEvents($id: String!, $companyId: Int, $pageId: String) {
  recordingSession(id: $id, companyId: $companyId, pageId: $pageId) {
    id
    unzippedEvents {
      events
      sessionId
      pageVisitUuid
      fileProcessingStats {
        processingTimeMs
        dataFileStats {
          numberOfFiles
          totalSizeKb
        }
      }
    }
    metadata {
      user
      device {
        isBot
        isTelevision
        isMobile
        isDesktop
        device {
          brand
          model
          type
        }
        client {
          name
          type
          version
        }
        os {
          name
          version
        }
      }
      language
      timeZone
      region
    }
  }
}
    `;

/**
 * __useGetRecordingSessionUnzippedEventsQuery__
 *
 * To run a query within a React component, call `useGetRecordingSessionUnzippedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordingSessionUnzippedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordingSessionUnzippedEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useGetRecordingSessionUnzippedEventsQuery(baseOptions: Apollo.QueryHookOptions<GetRecordingSessionUnzippedEventsQuery, GetRecordingSessionUnzippedEventsQueryVariables> & ({ variables: GetRecordingSessionUnzippedEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecordingSessionUnzippedEventsQuery, GetRecordingSessionUnzippedEventsQueryVariables>(GetRecordingSessionUnzippedEventsDocument, options);
      }
export function useGetRecordingSessionUnzippedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecordingSessionUnzippedEventsQuery, GetRecordingSessionUnzippedEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecordingSessionUnzippedEventsQuery, GetRecordingSessionUnzippedEventsQueryVariables>(GetRecordingSessionUnzippedEventsDocument, options);
        }
export function useGetRecordingSessionUnzippedEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecordingSessionUnzippedEventsQuery, GetRecordingSessionUnzippedEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecordingSessionUnzippedEventsQuery, GetRecordingSessionUnzippedEventsQueryVariables>(GetRecordingSessionUnzippedEventsDocument, options);
        }
export type GetRecordingSessionUnzippedEventsQueryHookResult = ReturnType<typeof useGetRecordingSessionUnzippedEventsQuery>;
export type GetRecordingSessionUnzippedEventsLazyQueryHookResult = ReturnType<typeof useGetRecordingSessionUnzippedEventsLazyQuery>;
export type GetRecordingSessionUnzippedEventsSuspenseQueryHookResult = ReturnType<typeof useGetRecordingSessionUnzippedEventsSuspenseQuery>;
export type GetRecordingSessionUnzippedEventsQueryResult = Apollo.QueryResult<GetRecordingSessionUnzippedEventsQuery, GetRecordingSessionUnzippedEventsQueryVariables>;
export const GetGroupedRecordingSessionsForUserDocument = gql`
    query GetGroupedRecordingSessionsForUser($companyId: Int!, $userId: String!) {
  getGroupedRecordingSessionsForUser(companyId: $companyId, userId: $userId) {
    userId
    userInteractions {
      desktop {
        clicks {
          timestamp
          type
          element
          textContent
          children
          details
          recordingId
        }
        pageNavigations {
          timestamp
          url
          details
          recordingId
        }
        textEdits {
          timestamp
          element
          attributes
          title
          placeholder
          children
          details
          recordingId
        }
      }
      mobile {
        clicks {
          timestamp
          type
          element
          textContent
          children
          details
          recordingId
        }
        pageNavigations {
          timestamp
          url
          details
          recordingId
        }
        textEdits {
          timestamp
          element
          attributes
          title
          placeholder
          children
          details
          recordingId
        }
      }
    }
    recordings {
      id
      startTimestamp
      durationMs
      pageVisits {
        id
        activeFrom
        activeUntil
      }
      userActionsCount
      metadata {
        user
        device {
          isBot
          isTelevision
          isMobile
          isDesktop
          device {
            brand
            model
            type
          }
          client {
            name
            type
            version
          }
          os {
            name
            version
          }
        }
        language
        timeZone
        region
      }
    }
  }
}
    `;

/**
 * __useGetGroupedRecordingSessionsForUserQuery__
 *
 * To run a query within a React component, call `useGetGroupedRecordingSessionsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupedRecordingSessionsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupedRecordingSessionsForUserQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetGroupedRecordingSessionsForUserQuery(baseOptions: Apollo.QueryHookOptions<GetGroupedRecordingSessionsForUserQuery, GetGroupedRecordingSessionsForUserQueryVariables> & ({ variables: GetGroupedRecordingSessionsForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupedRecordingSessionsForUserQuery, GetGroupedRecordingSessionsForUserQueryVariables>(GetGroupedRecordingSessionsForUserDocument, options);
      }
export function useGetGroupedRecordingSessionsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupedRecordingSessionsForUserQuery, GetGroupedRecordingSessionsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupedRecordingSessionsForUserQuery, GetGroupedRecordingSessionsForUserQueryVariables>(GetGroupedRecordingSessionsForUserDocument, options);
        }
export function useGetGroupedRecordingSessionsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupedRecordingSessionsForUserQuery, GetGroupedRecordingSessionsForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupedRecordingSessionsForUserQuery, GetGroupedRecordingSessionsForUserQueryVariables>(GetGroupedRecordingSessionsForUserDocument, options);
        }
export type GetGroupedRecordingSessionsForUserQueryHookResult = ReturnType<typeof useGetGroupedRecordingSessionsForUserQuery>;
export type GetGroupedRecordingSessionsForUserLazyQueryHookResult = ReturnType<typeof useGetGroupedRecordingSessionsForUserLazyQuery>;
export type GetGroupedRecordingSessionsForUserSuspenseQueryHookResult = ReturnType<typeof useGetGroupedRecordingSessionsForUserSuspenseQuery>;
export type GetGroupedRecordingSessionsForUserQueryResult = Apollo.QueryResult<GetGroupedRecordingSessionsForUserQuery, GetGroupedRecordingSessionsForUserQueryVariables>;
export const GetJsSnippetConfigParametersDocument = gql`
    query GetJsSnippetConfigParameters($companyId: Int) {
  jsSnippetConfigParameters(companyId: $companyId) {
    backendApi
    apiKey
    scriptSource
  }
}
    `;

/**
 * __useGetJsSnippetConfigParametersQuery__
 *
 * To run a query within a React component, call `useGetJsSnippetConfigParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJsSnippetConfigParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJsSnippetConfigParametersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetJsSnippetConfigParametersQuery(baseOptions?: Apollo.QueryHookOptions<GetJsSnippetConfigParametersQuery, GetJsSnippetConfigParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJsSnippetConfigParametersQuery, GetJsSnippetConfigParametersQueryVariables>(GetJsSnippetConfigParametersDocument, options);
      }
export function useGetJsSnippetConfigParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJsSnippetConfigParametersQuery, GetJsSnippetConfigParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJsSnippetConfigParametersQuery, GetJsSnippetConfigParametersQueryVariables>(GetJsSnippetConfigParametersDocument, options);
        }
export function useGetJsSnippetConfigParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJsSnippetConfigParametersQuery, GetJsSnippetConfigParametersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJsSnippetConfigParametersQuery, GetJsSnippetConfigParametersQueryVariables>(GetJsSnippetConfigParametersDocument, options);
        }
export type GetJsSnippetConfigParametersQueryHookResult = ReturnType<typeof useGetJsSnippetConfigParametersQuery>;
export type GetJsSnippetConfigParametersLazyQueryHookResult = ReturnType<typeof useGetJsSnippetConfigParametersLazyQuery>;
export type GetJsSnippetConfigParametersSuspenseQueryHookResult = ReturnType<typeof useGetJsSnippetConfigParametersSuspenseQuery>;
export type GetJsSnippetConfigParametersQueryResult = Apollo.QueryResult<GetJsSnippetConfigParametersQuery, GetJsSnippetConfigParametersQueryVariables>;
export const GetSiteSettingsDocument = gql`
    query GetSiteSettings($companyId: Int) {
  siteSettings(companyId: $companyId) {
    apiKey
    backendApi
    sailfishBackendApi
    defaultBackendApiUrl
    defaultSailfishBackendApiUrl
    isDefaultBackendApiUrl
    isDefaultSailfishBackendApiUrl
  }
}
    `;

/**
 * __useGetSiteSettingsQuery__
 *
 * To run a query within a React component, call `useGetSiteSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteSettingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetSiteSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSiteSettingsQuery, GetSiteSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteSettingsQuery, GetSiteSettingsQueryVariables>(GetSiteSettingsDocument, options);
      }
export function useGetSiteSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteSettingsQuery, GetSiteSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteSettingsQuery, GetSiteSettingsQueryVariables>(GetSiteSettingsDocument, options);
        }
export function useGetSiteSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSiteSettingsQuery, GetSiteSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteSettingsQuery, GetSiteSettingsQueryVariables>(GetSiteSettingsDocument, options);
        }
export type GetSiteSettingsQueryHookResult = ReturnType<typeof useGetSiteSettingsQuery>;
export type GetSiteSettingsLazyQueryHookResult = ReturnType<typeof useGetSiteSettingsLazyQuery>;
export type GetSiteSettingsSuspenseQueryHookResult = ReturnType<typeof useGetSiteSettingsSuspenseQuery>;
export type GetSiteSettingsQueryResult = Apollo.QueryResult<GetSiteSettingsQuery, GetSiteSettingsQueryVariables>;
export const UpdateSiteSettingsDocument = gql`
    mutation UpdateSiteSettings($input: SiteSettingsInput!, $companyId: Int) {
  updateSiteSettings(input: $input, companyId: $companyId) {
    backendApi
    sailfishBackendApi
    isDefaultBackendApiUrl
    isDefaultSailfishBackendApiUrl
  }
}
    `;
export type UpdateSiteSettingsMutationFn = Apollo.MutationFunction<UpdateSiteSettingsMutation, UpdateSiteSettingsMutationVariables>;

/**
 * __useUpdateSiteSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSiteSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteSettingsMutation, { data, loading, error }] = useUpdateSiteSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUpdateSiteSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteSettingsMutation, UpdateSiteSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteSettingsMutation, UpdateSiteSettingsMutationVariables>(UpdateSiteSettingsDocument, options);
      }
export type UpdateSiteSettingsMutationHookResult = ReturnType<typeof useUpdateSiteSettingsMutation>;
export type UpdateSiteSettingsMutationResult = Apollo.MutationResult<UpdateSiteSettingsMutation>;
export type UpdateSiteSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSiteSettingsMutation, UpdateSiteSettingsMutationVariables>;
export const GetCaptureSettingsDocument = gql`
    query GetCaptureSettings($companyId: Int) {
  captureSettings(companyId: $companyId) {
    recordCanvas
    recordCrossOriginIframes
    collectFonts
    inlineImages
    sampling
    recordPassword
    recordRealName
    recordCreditCardInfo
    recordSsn
    recordDob
    canEdit
    ignoreDomains
    cssFromDomain
    cssToDomain
  }
}
    `;

/**
 * __useGetCaptureSettingsQuery__
 *
 * To run a query within a React component, call `useGetCaptureSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaptureSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaptureSettingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCaptureSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetCaptureSettingsQuery, GetCaptureSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaptureSettingsQuery, GetCaptureSettingsQueryVariables>(GetCaptureSettingsDocument, options);
      }
export function useGetCaptureSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaptureSettingsQuery, GetCaptureSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaptureSettingsQuery, GetCaptureSettingsQueryVariables>(GetCaptureSettingsDocument, options);
        }
export function useGetCaptureSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaptureSettingsQuery, GetCaptureSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaptureSettingsQuery, GetCaptureSettingsQueryVariables>(GetCaptureSettingsDocument, options);
        }
export type GetCaptureSettingsQueryHookResult = ReturnType<typeof useGetCaptureSettingsQuery>;
export type GetCaptureSettingsLazyQueryHookResult = ReturnType<typeof useGetCaptureSettingsLazyQuery>;
export type GetCaptureSettingsSuspenseQueryHookResult = ReturnType<typeof useGetCaptureSettingsSuspenseQuery>;
export type GetCaptureSettingsQueryResult = Apollo.QueryResult<GetCaptureSettingsQuery, GetCaptureSettingsQueryVariables>;
export const UpdateCaptureSettingsDocument = gql`
    mutation UpdateCaptureSettings($input: CaptureSettingsInput!) {
  updateCaptureSettings(input: $input) {
    recordCanvas
    recordCrossOriginIframes
    collectFonts
    inlineImages
    sampling
    recordPassword
    recordRealName
    recordCreditCardInfo
    recordSsn
    recordDob
    ignoreDomains
    cssFromDomain
    cssToDomain
  }
}
    `;
export type UpdateCaptureSettingsMutationFn = Apollo.MutationFunction<UpdateCaptureSettingsMutation, UpdateCaptureSettingsMutationVariables>;

/**
 * __useUpdateCaptureSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCaptureSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaptureSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaptureSettingsMutation, { data, loading, error }] = useUpdateCaptureSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaptureSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaptureSettingsMutation, UpdateCaptureSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaptureSettingsMutation, UpdateCaptureSettingsMutationVariables>(UpdateCaptureSettingsDocument, options);
      }
export type UpdateCaptureSettingsMutationHookResult = ReturnType<typeof useUpdateCaptureSettingsMutation>;
export type UpdateCaptureSettingsMutationResult = Apollo.MutationResult<UpdateCaptureSettingsMutation>;
export type UpdateCaptureSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCaptureSettingsMutation, UpdateCaptureSettingsMutationVariables>;
export const GetStatusItemsDocument = gql`
    query GetStatusItems($companyId: Int) {
  statusItems(companyId: $companyId) {
    integrations {
      title
      link
      tooltipText
      isWorking
    }
  }
}
    `;

/**
 * __useGetStatusItemsQuery__
 *
 * To run a query within a React component, call `useGetStatusItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusItemsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetStatusItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetStatusItemsQuery, GetStatusItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusItemsQuery, GetStatusItemsQueryVariables>(GetStatusItemsDocument, options);
      }
export function useGetStatusItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusItemsQuery, GetStatusItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusItemsQuery, GetStatusItemsQueryVariables>(GetStatusItemsDocument, options);
        }
export function useGetStatusItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatusItemsQuery, GetStatusItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStatusItemsQuery, GetStatusItemsQueryVariables>(GetStatusItemsDocument, options);
        }
export type GetStatusItemsQueryHookResult = ReturnType<typeof useGetStatusItemsQuery>;
export type GetStatusItemsLazyQueryHookResult = ReturnType<typeof useGetStatusItemsLazyQuery>;
export type GetStatusItemsSuspenseQueryHookResult = ReturnType<typeof useGetStatusItemsSuspenseQuery>;
export type GetStatusItemsQueryResult = Apollo.QueryResult<GetStatusItemsQuery, GetStatusItemsQueryVariables>;
export const GetNotificationSettingsDocument = gql`
    query GetNotificationSettings($companyId: Int) {
  getNotificationSettings(companyId: $companyId) {
    emailNotificationSettings {
      defaultRecipients
      timeBetweenSuccessiveNotificationsPerIssue
    }
    webhookNotificationSettings {
      timeBetweenSuccessiveNotificationsPerIssue
    }
    notificationWebhooks {
      id
      webhookDataType
      destinationAddress
      authentication
    }
  }
}
    `;

/**
 * __useGetNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationSettingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetNotificationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(GetNotificationSettingsDocument, options);
      }
export function useGetNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(GetNotificationSettingsDocument, options);
        }
export function useGetNotificationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(GetNotificationSettingsDocument, options);
        }
export type GetNotificationSettingsQueryHookResult = ReturnType<typeof useGetNotificationSettingsQuery>;
export type GetNotificationSettingsLazyQueryHookResult = ReturnType<typeof useGetNotificationSettingsLazyQuery>;
export type GetNotificationSettingsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationSettingsSuspenseQuery>;
export type GetNotificationSettingsQueryResult = Apollo.QueryResult<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>;
export const UpdateNotificationSettingsDocument = gql`
    mutation UpdateNotificationSettings($emailInput: EmailNotificationSettingsInput, $webhookInput: WebhookNotificationSettingsInput, $webhooks: [NotificationWebhookInput!], $companyId: Int) {
  updateNotificationSettings(
    emailSettings: $emailInput
    webhookSettings: $webhookInput
    webhooks: $webhooks
    companyId: $companyId
  )
}
    `;
export type UpdateNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;

/**
 * __useUpdateNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationSettingsMutation, { data, loading, error }] = useUpdateNotificationSettingsMutation({
 *   variables: {
 *      emailInput: // value for 'emailInput'
 *      webhookInput: // value for 'webhookInput'
 *      webhooks: // value for 'webhooks'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUpdateNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>(UpdateNotificationSettingsDocument, options);
      }
export type UpdateNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateNotificationSettingsMutation>;
export type UpdateNotificationSettingsMutationResult = Apollo.MutationResult<UpdateNotificationSettingsMutation>;
export type UpdateNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;
export const FollowIssueDocument = gql`
    mutation FollowIssue($input: FollowIssueInput!) {
  followIssue(input: $input)
}
    `;
export type FollowIssueMutationFn = Apollo.MutationFunction<FollowIssueMutation, FollowIssueMutationVariables>;

/**
 * __useFollowIssueMutation__
 *
 * To run a mutation, you first call `useFollowIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followIssueMutation, { data, loading, error }] = useFollowIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFollowIssueMutation(baseOptions?: Apollo.MutationHookOptions<FollowIssueMutation, FollowIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowIssueMutation, FollowIssueMutationVariables>(FollowIssueDocument, options);
      }
export type FollowIssueMutationHookResult = ReturnType<typeof useFollowIssueMutation>;
export type FollowIssueMutationResult = Apollo.MutationResult<FollowIssueMutation>;
export type FollowIssueMutationOptions = Apollo.BaseMutationOptions<FollowIssueMutation, FollowIssueMutationVariables>;
export const UnfollowIssueDocument = gql`
    mutation UnfollowIssue($input: FollowIssueInput!) {
  unfollowIssue(input: $input)
}
    `;
export type UnfollowIssueMutationFn = Apollo.MutationFunction<UnfollowIssueMutation, UnfollowIssueMutationVariables>;

/**
 * __useUnfollowIssueMutation__
 *
 * To run a mutation, you first call `useUnfollowIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowIssueMutation, { data, loading, error }] = useUnfollowIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnfollowIssueMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowIssueMutation, UnfollowIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowIssueMutation, UnfollowIssueMutationVariables>(UnfollowIssueDocument, options);
      }
export type UnfollowIssueMutationHookResult = ReturnType<typeof useUnfollowIssueMutation>;
export type UnfollowIssueMutationResult = Apollo.MutationResult<UnfollowIssueMutation>;
export type UnfollowIssueMutationOptions = Apollo.BaseMutationOptions<UnfollowIssueMutation, UnfollowIssueMutationVariables>;
export const ToggleIssueFollowingStatusForUserDocument = gql`
    mutation ToggleIssueFollowingStatusForUser($input: ToggleFollowIssueInput!, $companyId: Int) {
  toggleIssueFollowingStatusForUser(input: $input, companyId: $companyId)
}
    `;
export type ToggleIssueFollowingStatusForUserMutationFn = Apollo.MutationFunction<ToggleIssueFollowingStatusForUserMutation, ToggleIssueFollowingStatusForUserMutationVariables>;

/**
 * __useToggleIssueFollowingStatusForUserMutation__
 *
 * To run a mutation, you first call `useToggleIssueFollowingStatusForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleIssueFollowingStatusForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleIssueFollowingStatusForUserMutation, { data, loading, error }] = useToggleIssueFollowingStatusForUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useToggleIssueFollowingStatusForUserMutation(baseOptions?: Apollo.MutationHookOptions<ToggleIssueFollowingStatusForUserMutation, ToggleIssueFollowingStatusForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleIssueFollowingStatusForUserMutation, ToggleIssueFollowingStatusForUserMutationVariables>(ToggleIssueFollowingStatusForUserDocument, options);
      }
export type ToggleIssueFollowingStatusForUserMutationHookResult = ReturnType<typeof useToggleIssueFollowingStatusForUserMutation>;
export type ToggleIssueFollowingStatusForUserMutationResult = Apollo.MutationResult<ToggleIssueFollowingStatusForUserMutation>;
export type ToggleIssueFollowingStatusForUserMutationOptions = Apollo.BaseMutationOptions<ToggleIssueFollowingStatusForUserMutation, ToggleIssueFollowingStatusForUserMutationVariables>;
export const ToggleIssueResolvedStatusDocument = gql`
    mutation ToggleIssueResolvedStatus($input: ResolveIssueInput!, $companyId: Int) {
  toggleIssueResolvedStatus(input: $input, companyId: $companyId)
}
    `;
export type ToggleIssueResolvedStatusMutationFn = Apollo.MutationFunction<ToggleIssueResolvedStatusMutation, ToggleIssueResolvedStatusMutationVariables>;

/**
 * __useToggleIssueResolvedStatusMutation__
 *
 * To run a mutation, you first call `useToggleIssueResolvedStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleIssueResolvedStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleIssueResolvedStatusMutation, { data, loading, error }] = useToggleIssueResolvedStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useToggleIssueResolvedStatusMutation(baseOptions?: Apollo.MutationHookOptions<ToggleIssueResolvedStatusMutation, ToggleIssueResolvedStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleIssueResolvedStatusMutation, ToggleIssueResolvedStatusMutationVariables>(ToggleIssueResolvedStatusDocument, options);
      }
export type ToggleIssueResolvedStatusMutationHookResult = ReturnType<typeof useToggleIssueResolvedStatusMutation>;
export type ToggleIssueResolvedStatusMutationResult = Apollo.MutationResult<ToggleIssueResolvedStatusMutation>;
export type ToggleIssueResolvedStatusMutationOptions = Apollo.BaseMutationOptions<ToggleIssueResolvedStatusMutation, ToggleIssueResolvedStatusMutationVariables>;
export const SnoozeIssueDocument = gql`
    mutation SnoozeIssue($input: SnoozeIssueInput!, $companyId: Int) {
  snoozeIssue(input: $input, companyId: $companyId) {
    id
    snoozedMode
    snoozedUntil
    snoozedPermanently
  }
}
    `;
export type SnoozeIssueMutationFn = Apollo.MutationFunction<SnoozeIssueMutation, SnoozeIssueMutationVariables>;

/**
 * __useSnoozeIssueMutation__
 *
 * To run a mutation, you first call `useSnoozeIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnoozeIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snoozeIssueMutation, { data, loading, error }] = useSnoozeIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSnoozeIssueMutation(baseOptions?: Apollo.MutationHookOptions<SnoozeIssueMutation, SnoozeIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnoozeIssueMutation, SnoozeIssueMutationVariables>(SnoozeIssueDocument, options);
      }
export type SnoozeIssueMutationHookResult = ReturnType<typeof useSnoozeIssueMutation>;
export type SnoozeIssueMutationResult = Apollo.MutationResult<SnoozeIssueMutation>;
export type SnoozeIssueMutationOptions = Apollo.BaseMutationOptions<SnoozeIssueMutation, SnoozeIssueMutationVariables>;
export const GetEngineeringTicketPlatformIntegrationConfigsDocument = gql`
    query GetEngineeringTicketPlatformIntegrationConfigs($companyId: Int) {
  getEngineeringTicketPlatformIntegrationConfigs(companyId: $companyId) {
    clientId
    provider
  }
}
    `;

/**
 * __useGetEngineeringTicketPlatformIntegrationConfigsQuery__
 *
 * To run a query within a React component, call `useGetEngineeringTicketPlatformIntegrationConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngineeringTicketPlatformIntegrationConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngineeringTicketPlatformIntegrationConfigsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEngineeringTicketPlatformIntegrationConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetEngineeringTicketPlatformIntegrationConfigsQuery, GetEngineeringTicketPlatformIntegrationConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEngineeringTicketPlatformIntegrationConfigsQuery, GetEngineeringTicketPlatformIntegrationConfigsQueryVariables>(GetEngineeringTicketPlatformIntegrationConfigsDocument, options);
      }
export function useGetEngineeringTicketPlatformIntegrationConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEngineeringTicketPlatformIntegrationConfigsQuery, GetEngineeringTicketPlatformIntegrationConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEngineeringTicketPlatformIntegrationConfigsQuery, GetEngineeringTicketPlatformIntegrationConfigsQueryVariables>(GetEngineeringTicketPlatformIntegrationConfigsDocument, options);
        }
export function useGetEngineeringTicketPlatformIntegrationConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEngineeringTicketPlatformIntegrationConfigsQuery, GetEngineeringTicketPlatformIntegrationConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEngineeringTicketPlatformIntegrationConfigsQuery, GetEngineeringTicketPlatformIntegrationConfigsQueryVariables>(GetEngineeringTicketPlatformIntegrationConfigsDocument, options);
        }
export type GetEngineeringTicketPlatformIntegrationConfigsQueryHookResult = ReturnType<typeof useGetEngineeringTicketPlatformIntegrationConfigsQuery>;
export type GetEngineeringTicketPlatformIntegrationConfigsLazyQueryHookResult = ReturnType<typeof useGetEngineeringTicketPlatformIntegrationConfigsLazyQuery>;
export type GetEngineeringTicketPlatformIntegrationConfigsSuspenseQueryHookResult = ReturnType<typeof useGetEngineeringTicketPlatformIntegrationConfigsSuspenseQuery>;
export type GetEngineeringTicketPlatformIntegrationConfigsQueryResult = Apollo.QueryResult<GetEngineeringTicketPlatformIntegrationConfigsQuery, GetEngineeringTicketPlatformIntegrationConfigsQueryVariables>;
export const GetEngineeringTicketPlatformIntegrationDocument = gql`
    query GetEngineeringTicketPlatformIntegration($provider: String!, $companyId: Int) {
  getEngineeringTicketPlatformIntegration(
    provider: $provider
    companyId: $companyId
  ) {
    pushAutoIdentifiedIssues
    clientId
    defaultPriority
    defaultProject
    defaultTeam
    installed
    projects
    teams
    workflowStates
  }
}
    `;

/**
 * __useGetEngineeringTicketPlatformIntegrationQuery__
 *
 * To run a query within a React component, call `useGetEngineeringTicketPlatformIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngineeringTicketPlatformIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngineeringTicketPlatformIntegrationQuery({
 *   variables: {
 *      provider: // value for 'provider'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEngineeringTicketPlatformIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GetEngineeringTicketPlatformIntegrationQuery, GetEngineeringTicketPlatformIntegrationQueryVariables> & ({ variables: GetEngineeringTicketPlatformIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEngineeringTicketPlatformIntegrationQuery, GetEngineeringTicketPlatformIntegrationQueryVariables>(GetEngineeringTicketPlatformIntegrationDocument, options);
      }
export function useGetEngineeringTicketPlatformIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEngineeringTicketPlatformIntegrationQuery, GetEngineeringTicketPlatformIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEngineeringTicketPlatformIntegrationQuery, GetEngineeringTicketPlatformIntegrationQueryVariables>(GetEngineeringTicketPlatformIntegrationDocument, options);
        }
export function useGetEngineeringTicketPlatformIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEngineeringTicketPlatformIntegrationQuery, GetEngineeringTicketPlatformIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEngineeringTicketPlatformIntegrationQuery, GetEngineeringTicketPlatformIntegrationQueryVariables>(GetEngineeringTicketPlatformIntegrationDocument, options);
        }
export type GetEngineeringTicketPlatformIntegrationQueryHookResult = ReturnType<typeof useGetEngineeringTicketPlatformIntegrationQuery>;
export type GetEngineeringTicketPlatformIntegrationLazyQueryHookResult = ReturnType<typeof useGetEngineeringTicketPlatformIntegrationLazyQuery>;
export type GetEngineeringTicketPlatformIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetEngineeringTicketPlatformIntegrationSuspenseQuery>;
export type GetEngineeringTicketPlatformIntegrationQueryResult = Apollo.QueryResult<GetEngineeringTicketPlatformIntegrationQuery, GetEngineeringTicketPlatformIntegrationQueryVariables>;
export const GetEngineeringTicketPlatformIntegrationsDocument = gql`
    query GetEngineeringTicketPlatformIntegrations($companyId: Int) {
  getEngineeringTicketPlatformIntegrations(companyId: $companyId) {
    pushAutoIdentifiedIssues
    provider
    clientId
    defaultPriority
    defaultProject
    defaultTeam
    installed
    projects
    teams
    workflowStates
  }
}
    `;

/**
 * __useGetEngineeringTicketPlatformIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetEngineeringTicketPlatformIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngineeringTicketPlatformIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngineeringTicketPlatformIntegrationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEngineeringTicketPlatformIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetEngineeringTicketPlatformIntegrationsQuery, GetEngineeringTicketPlatformIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEngineeringTicketPlatformIntegrationsQuery, GetEngineeringTicketPlatformIntegrationsQueryVariables>(GetEngineeringTicketPlatformIntegrationsDocument, options);
      }
export function useGetEngineeringTicketPlatformIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEngineeringTicketPlatformIntegrationsQuery, GetEngineeringTicketPlatformIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEngineeringTicketPlatformIntegrationsQuery, GetEngineeringTicketPlatformIntegrationsQueryVariables>(GetEngineeringTicketPlatformIntegrationsDocument, options);
        }
export function useGetEngineeringTicketPlatformIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEngineeringTicketPlatformIntegrationsQuery, GetEngineeringTicketPlatformIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEngineeringTicketPlatformIntegrationsQuery, GetEngineeringTicketPlatformIntegrationsQueryVariables>(GetEngineeringTicketPlatformIntegrationsDocument, options);
        }
export type GetEngineeringTicketPlatformIntegrationsQueryHookResult = ReturnType<typeof useGetEngineeringTicketPlatformIntegrationsQuery>;
export type GetEngineeringTicketPlatformIntegrationsLazyQueryHookResult = ReturnType<typeof useGetEngineeringTicketPlatformIntegrationsLazyQuery>;
export type GetEngineeringTicketPlatformIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetEngineeringTicketPlatformIntegrationsSuspenseQuery>;
export type GetEngineeringTicketPlatformIntegrationsQueryResult = Apollo.QueryResult<GetEngineeringTicketPlatformIntegrationsQuery, GetEngineeringTicketPlatformIntegrationsQueryVariables>;
export const AddGitHubIntegrationDocument = gql`
    mutation AddGitHubIntegration($installationId: String!, $setupAction: String!, $companyId: Int) {
  addGithubIntegration(
    installationId: $installationId
    setupAction: $setupAction
    companyId: $companyId
  ) {
    accountType
    installedOnAccount
    installedOnAllRepositories
    installedOnRepositories
  }
}
    `;
export type AddGitHubIntegrationMutationFn = Apollo.MutationFunction<AddGitHubIntegrationMutation, AddGitHubIntegrationMutationVariables>;

/**
 * __useAddGitHubIntegrationMutation__
 *
 * To run a mutation, you first call `useAddGitHubIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGitHubIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGitHubIntegrationMutation, { data, loading, error }] = useAddGitHubIntegrationMutation({
 *   variables: {
 *      installationId: // value for 'installationId'
 *      setupAction: // value for 'setupAction'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAddGitHubIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<AddGitHubIntegrationMutation, AddGitHubIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGitHubIntegrationMutation, AddGitHubIntegrationMutationVariables>(AddGitHubIntegrationDocument, options);
      }
export type AddGitHubIntegrationMutationHookResult = ReturnType<typeof useAddGitHubIntegrationMutation>;
export type AddGitHubIntegrationMutationResult = Apollo.MutationResult<AddGitHubIntegrationMutation>;
export type AddGitHubIntegrationMutationOptions = Apollo.BaseMutationOptions<AddGitHubIntegrationMutation, AddGitHubIntegrationMutationVariables>;
export const GetGithubIntegrationsDocument = gql`
    query GetGithubIntegrations($companyId: Int) {
  getGithubIntegrations(companyId: $companyId) {
    accountType
    installationId
    installedOnAccount
    installedOnAllRepositories
    installedOnRepositories
  }
}
    `;

/**
 * __useGetGithubIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetGithubIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGithubIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGithubIntegrationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetGithubIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetGithubIntegrationsQuery, GetGithubIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGithubIntegrationsQuery, GetGithubIntegrationsQueryVariables>(GetGithubIntegrationsDocument, options);
      }
export function useGetGithubIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGithubIntegrationsQuery, GetGithubIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGithubIntegrationsQuery, GetGithubIntegrationsQueryVariables>(GetGithubIntegrationsDocument, options);
        }
export function useGetGithubIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGithubIntegrationsQuery, GetGithubIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGithubIntegrationsQuery, GetGithubIntegrationsQueryVariables>(GetGithubIntegrationsDocument, options);
        }
export type GetGithubIntegrationsQueryHookResult = ReturnType<typeof useGetGithubIntegrationsQuery>;
export type GetGithubIntegrationsLazyQueryHookResult = ReturnType<typeof useGetGithubIntegrationsLazyQuery>;
export type GetGithubIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetGithubIntegrationsSuspenseQuery>;
export type GetGithubIntegrationsQueryResult = Apollo.QueryResult<GetGithubIntegrationsQuery, GetGithubIntegrationsQueryVariables>;
export const CreateEngineeringTicketPlatformIntegrationDocument = gql`
    mutation CreateEngineeringTicketPlatformIntegration($input: CreateEngineeringTicketPlatformIntegrationInput!, $inputProvider: CreateEngineeringTicketPlatformIntegrationConfig!, $companyId: Int) {
  createEngineeringTicketPlatformIntegration(
    input: $input
    inputProvider: $inputProvider
    companyId: $companyId
  ) {
    pushAutoIdentifiedIssues
    defaultPriority
    defaultProject
    defaultTeam
  }
}
    `;
export type CreateEngineeringTicketPlatformIntegrationMutationFn = Apollo.MutationFunction<CreateEngineeringTicketPlatformIntegrationMutation, CreateEngineeringTicketPlatformIntegrationMutationVariables>;

/**
 * __useCreateEngineeringTicketPlatformIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateEngineeringTicketPlatformIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEngineeringTicketPlatformIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEngineeringTicketPlatformIntegrationMutation, { data, loading, error }] = useCreateEngineeringTicketPlatformIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      inputProvider: // value for 'inputProvider'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCreateEngineeringTicketPlatformIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateEngineeringTicketPlatformIntegrationMutation, CreateEngineeringTicketPlatformIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEngineeringTicketPlatformIntegrationMutation, CreateEngineeringTicketPlatformIntegrationMutationVariables>(CreateEngineeringTicketPlatformIntegrationDocument, options);
      }
export type CreateEngineeringTicketPlatformIntegrationMutationHookResult = ReturnType<typeof useCreateEngineeringTicketPlatformIntegrationMutation>;
export type CreateEngineeringTicketPlatformIntegrationMutationResult = Apollo.MutationResult<CreateEngineeringTicketPlatformIntegrationMutation>;
export type CreateEngineeringTicketPlatformIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateEngineeringTicketPlatformIntegrationMutation, CreateEngineeringTicketPlatformIntegrationMutationVariables>;
export const UpdateEngineeringTicketPlatformIntegrationDocument = gql`
    mutation UpdateEngineeringTicketPlatformIntegration($input: EditEngineeringTicketPlatformIntegrationInput!, $companyId: Int) {
  updateEngineeringTicketPlatformIntegration(input: $input, companyId: $companyId) {
    pushAutoIdentifiedIssues
    defaultPriority
    defaultProject
    defaultTeam
  }
}
    `;
export type UpdateEngineeringTicketPlatformIntegrationMutationFn = Apollo.MutationFunction<UpdateEngineeringTicketPlatformIntegrationMutation, UpdateEngineeringTicketPlatformIntegrationMutationVariables>;

/**
 * __useUpdateEngineeringTicketPlatformIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateEngineeringTicketPlatformIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngineeringTicketPlatformIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngineeringTicketPlatformIntegrationMutation, { data, loading, error }] = useUpdateEngineeringTicketPlatformIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUpdateEngineeringTicketPlatformIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEngineeringTicketPlatformIntegrationMutation, UpdateEngineeringTicketPlatformIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEngineeringTicketPlatformIntegrationMutation, UpdateEngineeringTicketPlatformIntegrationMutationVariables>(UpdateEngineeringTicketPlatformIntegrationDocument, options);
      }
export type UpdateEngineeringTicketPlatformIntegrationMutationHookResult = ReturnType<typeof useUpdateEngineeringTicketPlatformIntegrationMutation>;
export type UpdateEngineeringTicketPlatformIntegrationMutationResult = Apollo.MutationResult<UpdateEngineeringTicketPlatformIntegrationMutation>;
export type UpdateEngineeringTicketPlatformIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateEngineeringTicketPlatformIntegrationMutation, UpdateEngineeringTicketPlatformIntegrationMutationVariables>;
export const GetMessagingPlatformIntegrationsDocument = gql`
    query GetMessagingPlatformIntegrations($companyId: Int) {
  getMessagingPlatformIntegrations(companyId: $companyId) {
    provider
    slackIntegration {
      appId
      teamId
      teamName
      botUserId
      defaultEngineeringCollaborationChannel
    }
  }
}
    `;

/**
 * __useGetMessagingPlatformIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetMessagingPlatformIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagingPlatformIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagingPlatformIntegrationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetMessagingPlatformIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMessagingPlatformIntegrationsQuery, GetMessagingPlatformIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagingPlatformIntegrationsQuery, GetMessagingPlatformIntegrationsQueryVariables>(GetMessagingPlatformIntegrationsDocument, options);
      }
export function useGetMessagingPlatformIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagingPlatformIntegrationsQuery, GetMessagingPlatformIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagingPlatformIntegrationsQuery, GetMessagingPlatformIntegrationsQueryVariables>(GetMessagingPlatformIntegrationsDocument, options);
        }
export function useGetMessagingPlatformIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessagingPlatformIntegrationsQuery, GetMessagingPlatformIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessagingPlatformIntegrationsQuery, GetMessagingPlatformIntegrationsQueryVariables>(GetMessagingPlatformIntegrationsDocument, options);
        }
export type GetMessagingPlatformIntegrationsQueryHookResult = ReturnType<typeof useGetMessagingPlatformIntegrationsQuery>;
export type GetMessagingPlatformIntegrationsLazyQueryHookResult = ReturnType<typeof useGetMessagingPlatformIntegrationsLazyQuery>;
export type GetMessagingPlatformIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetMessagingPlatformIntegrationsSuspenseQuery>;
export type GetMessagingPlatformIntegrationsQueryResult = Apollo.QueryResult<GetMessagingPlatformIntegrationsQuery, GetMessagingPlatformIntegrationsQueryVariables>;
export const CreateSlackIntegrationDocument = gql`
    mutation CreateSlackIntegration($code: String!, $companyId: Int) {
  createSlackIntegration(code: $code, companyId: $companyId) {
    appId
    teamId
    teamName
    botUserId
    defaultEngineeringCollaborationChannel
  }
}
    `;
export type CreateSlackIntegrationMutationFn = Apollo.MutationFunction<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>;

/**
 * __useCreateSlackIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateSlackIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlackIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlackIntegrationMutation, { data, loading, error }] = useCreateSlackIntegrationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCreateSlackIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>(CreateSlackIntegrationDocument, options);
      }
export type CreateSlackIntegrationMutationHookResult = ReturnType<typeof useCreateSlackIntegrationMutation>;
export type CreateSlackIntegrationMutationResult = Apollo.MutationResult<CreateSlackIntegrationMutation>;
export type CreateSlackIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>;
export const ListSlackChannelsDocument = gql`
    query ListSlackChannels($companyId: Int) {
  listSlackChannels(companyId: $companyId) {
    id
    name
  }
}
    `;

/**
 * __useListSlackChannelsQuery__
 *
 * To run a query within a React component, call `useListSlackChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSlackChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSlackChannelsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useListSlackChannelsQuery(baseOptions?: Apollo.QueryHookOptions<ListSlackChannelsQuery, ListSlackChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSlackChannelsQuery, ListSlackChannelsQueryVariables>(ListSlackChannelsDocument, options);
      }
export function useListSlackChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSlackChannelsQuery, ListSlackChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSlackChannelsQuery, ListSlackChannelsQueryVariables>(ListSlackChannelsDocument, options);
        }
export function useListSlackChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSlackChannelsQuery, ListSlackChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSlackChannelsQuery, ListSlackChannelsQueryVariables>(ListSlackChannelsDocument, options);
        }
export type ListSlackChannelsQueryHookResult = ReturnType<typeof useListSlackChannelsQuery>;
export type ListSlackChannelsLazyQueryHookResult = ReturnType<typeof useListSlackChannelsLazyQuery>;
export type ListSlackChannelsSuspenseQueryHookResult = ReturnType<typeof useListSlackChannelsSuspenseQuery>;
export type ListSlackChannelsQueryResult = Apollo.QueryResult<ListSlackChannelsQuery, ListSlackChannelsQueryVariables>;
export const UpdateSlackIntegrationDocument = gql`
    mutation UpdateSlackIntegration($input: EditSlackIntegrationInput!, $companyId: Int) {
  updateSlackIntegration(input: $input, companyId: $companyId)
}
    `;
export type UpdateSlackIntegrationMutationFn = Apollo.MutationFunction<UpdateSlackIntegrationMutation, UpdateSlackIntegrationMutationVariables>;

/**
 * __useUpdateSlackIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateSlackIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSlackIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSlackIntegrationMutation, { data, loading, error }] = useUpdateSlackIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUpdateSlackIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSlackIntegrationMutation, UpdateSlackIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSlackIntegrationMutation, UpdateSlackIntegrationMutationVariables>(UpdateSlackIntegrationDocument, options);
      }
export type UpdateSlackIntegrationMutationHookResult = ReturnType<typeof useUpdateSlackIntegrationMutation>;
export type UpdateSlackIntegrationMutationResult = Apollo.MutationResult<UpdateSlackIntegrationMutation>;
export type UpdateSlackIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateSlackIntegrationMutation, UpdateSlackIntegrationMutationVariables>;
export const CreateTriageDocument = gql`
    mutation CreateTriage($triageInfoRecordings: [TriageInputRecording!], $triageInfoSegment: TriageInputSegment, $triageInfoLogs: [TriageInputLogs!], $companyId: Int) {
  createTriage(
    triageInfoRecordings: $triageInfoRecordings
    triageInfoSegment: $triageInfoSegment
    triageInfoLogs: $triageInfoLogs
    companyId: $companyId
  ) {
    id
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;
export type CreateTriageMutationFn = Apollo.MutationFunction<CreateTriageMutation, CreateTriageMutationVariables>;

/**
 * __useCreateTriageMutation__
 *
 * To run a mutation, you first call `useCreateTriageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTriageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTriageMutation, { data, loading, error }] = useCreateTriageMutation({
 *   variables: {
 *      triageInfoRecordings: // value for 'triageInfoRecordings'
 *      triageInfoSegment: // value for 'triageInfoSegment'
 *      triageInfoLogs: // value for 'triageInfoLogs'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCreateTriageMutation(baseOptions?: Apollo.MutationHookOptions<CreateTriageMutation, CreateTriageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTriageMutation, CreateTriageMutationVariables>(CreateTriageDocument, options);
      }
export type CreateTriageMutationHookResult = ReturnType<typeof useCreateTriageMutation>;
export type CreateTriageMutationResult = Apollo.MutationResult<CreateTriageMutation>;
export type CreateTriageMutationOptions = Apollo.BaseMutationOptions<CreateTriageMutation, CreateTriageMutationVariables>;
export const GetTriageDocument = gql`
    query GetTriage($triageId: Int!, $companyId: Int) {
  getTriage(triageId: $triageId, companyId: $companyId) {
    isReady
    description
    affectedPercentageUsers
    change24h
    createdBy
    createdAt
    devices {
      isDesktop
      isMobile
      isBot
      isTelevision
      device {
        type
        brand
      }
    }
    lastSeen
    severity
    triageRecordingData {
      recording {
        ...RecordingFragment
      }
      timeWindows {
        timestampStart
        timestampEnd
      }
    }
    triageLogData {
      recording {
        ...RecordingFragment
      }
    }
    otherSimilarRecordings {
      recording {
        ...RecordingFragment
      }
    }
    updatedBy
  }
}
    ${RecordingFragmentFragmentDoc}`;

/**
 * __useGetTriageQuery__
 *
 * To run a query within a React component, call `useGetTriageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriageQuery({
 *   variables: {
 *      triageId: // value for 'triageId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetTriageQuery(baseOptions: Apollo.QueryHookOptions<GetTriageQuery, GetTriageQueryVariables> & ({ variables: GetTriageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriageQuery, GetTriageQueryVariables>(GetTriageDocument, options);
      }
export function useGetTriageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriageQuery, GetTriageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriageQuery, GetTriageQueryVariables>(GetTriageDocument, options);
        }
export function useGetTriageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriageQuery, GetTriageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTriageQuery, GetTriageQueryVariables>(GetTriageDocument, options);
        }
export type GetTriageQueryHookResult = ReturnType<typeof useGetTriageQuery>;
export type GetTriageLazyQueryHookResult = ReturnType<typeof useGetTriageLazyQuery>;
export type GetTriageSuspenseQueryHookResult = ReturnType<typeof useGetTriageSuspenseQuery>;
export type GetTriageQueryResult = Apollo.QueryResult<GetTriageQuery, GetTriageQueryVariables>;
export const FetchSessionLogsDocument = gql`
    query FetchSessionLogs($sessionId: String!, $pageVisitUuids: [String!]!, $companyId: Int) {
  fetchSessionLogs(
    sessionId: $sessionId
    pageVisitUuids: $pageVisitUuids
    companyId: $companyId
  ) {
    sessionId
    pageVisitUuid
    frontendConsoleLogs {
      logs
      fileProcessingStats {
        processingTimeMs
        dataFileStats {
          numberOfFiles
          totalSizeKb
        }
      }
    }
    networkRequestData {
      networkRequestData {
        requestId
        logs
        printStatements
        exceptions
        fileProcessingStats {
          processingTimeMs
          dataFileStats {
            numberOfFiles
            totalSizeKb
          }
        }
      }
      fileProcessingStats {
        processingTimeMs
        dataFileStats {
          numberOfFiles
          totalSizeKb
        }
      }
    }
  }
}
    `;

/**
 * __useFetchSessionLogsQuery__
 *
 * To run a query within a React component, call `useFetchSessionLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSessionLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSessionLogsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      pageVisitUuids: // value for 'pageVisitUuids'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchSessionLogsQuery(baseOptions: Apollo.QueryHookOptions<FetchSessionLogsQuery, FetchSessionLogsQueryVariables> & ({ variables: FetchSessionLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSessionLogsQuery, FetchSessionLogsQueryVariables>(FetchSessionLogsDocument, options);
      }
export function useFetchSessionLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSessionLogsQuery, FetchSessionLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSessionLogsQuery, FetchSessionLogsQueryVariables>(FetchSessionLogsDocument, options);
        }
export function useFetchSessionLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchSessionLogsQuery, FetchSessionLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchSessionLogsQuery, FetchSessionLogsQueryVariables>(FetchSessionLogsDocument, options);
        }
export type FetchSessionLogsQueryHookResult = ReturnType<typeof useFetchSessionLogsQuery>;
export type FetchSessionLogsLazyQueryHookResult = ReturnType<typeof useFetchSessionLogsLazyQuery>;
export type FetchSessionLogsSuspenseQueryHookResult = ReturnType<typeof useFetchSessionLogsSuspenseQuery>;
export type FetchSessionLogsQueryResult = Apollo.QueryResult<FetchSessionLogsQuery, FetchSessionLogsQueryVariables>;
export const GetFeatureRequestsDocument = gql`
    query GetFeatureRequests {
  featureRequests {
    id
    title
    description
    totalVotes
    companiesVoted
    dateRequested
    lastUpdate
    votedByUser
  }
}
    `;

/**
 * __useGetFeatureRequestsQuery__
 *
 * To run a query within a React component, call `useGetFeatureRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetFeatureRequestsQuery, GetFeatureRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureRequestsQuery, GetFeatureRequestsQueryVariables>(GetFeatureRequestsDocument, options);
      }
export function useGetFeatureRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureRequestsQuery, GetFeatureRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureRequestsQuery, GetFeatureRequestsQueryVariables>(GetFeatureRequestsDocument, options);
        }
export function useGetFeatureRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeatureRequestsQuery, GetFeatureRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeatureRequestsQuery, GetFeatureRequestsQueryVariables>(GetFeatureRequestsDocument, options);
        }
export type GetFeatureRequestsQueryHookResult = ReturnType<typeof useGetFeatureRequestsQuery>;
export type GetFeatureRequestsLazyQueryHookResult = ReturnType<typeof useGetFeatureRequestsLazyQuery>;
export type GetFeatureRequestsSuspenseQueryHookResult = ReturnType<typeof useGetFeatureRequestsSuspenseQuery>;
export type GetFeatureRequestsQueryResult = Apollo.QueryResult<GetFeatureRequestsQuery, GetFeatureRequestsQueryVariables>;
export const SubmitFeatureRequestDocument = gql`
    mutation SubmitFeatureRequest($title: String!, $description: String!) {
  submitFeatureRequest(title: $title, description: $description) {
    id
    title
    description
    totalVotes
    companiesVoted
    dateRequested
    lastUpdate
  }
}
    `;
export type SubmitFeatureRequestMutationFn = Apollo.MutationFunction<SubmitFeatureRequestMutation, SubmitFeatureRequestMutationVariables>;

/**
 * __useSubmitFeatureRequestMutation__
 *
 * To run a mutation, you first call `useSubmitFeatureRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFeatureRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFeatureRequestMutation, { data, loading, error }] = useSubmitFeatureRequestMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useSubmitFeatureRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFeatureRequestMutation, SubmitFeatureRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFeatureRequestMutation, SubmitFeatureRequestMutationVariables>(SubmitFeatureRequestDocument, options);
      }
export type SubmitFeatureRequestMutationHookResult = ReturnType<typeof useSubmitFeatureRequestMutation>;
export type SubmitFeatureRequestMutationResult = Apollo.MutationResult<SubmitFeatureRequestMutation>;
export type SubmitFeatureRequestMutationOptions = Apollo.BaseMutationOptions<SubmitFeatureRequestMutation, SubmitFeatureRequestMutationVariables>;
export const ToggleVoteDocument = gql`
    mutation ToggleVote($requestId: ID!) {
  toggleVote(requestId: $requestId) {
    id
    totalVotes
    votedByUser
  }
}
    `;
export type ToggleVoteMutationFn = Apollo.MutationFunction<ToggleVoteMutation, ToggleVoteMutationVariables>;

/**
 * __useToggleVoteMutation__
 *
 * To run a mutation, you first call `useToggleVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleVoteMutation, { data, loading, error }] = useToggleVoteMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useToggleVoteMutation(baseOptions?: Apollo.MutationHookOptions<ToggleVoteMutation, ToggleVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleVoteMutation, ToggleVoteMutationVariables>(ToggleVoteDocument, options);
      }
export type ToggleVoteMutationHookResult = ReturnType<typeof useToggleVoteMutation>;
export type ToggleVoteMutationResult = Apollo.MutationResult<ToggleVoteMutation>;
export type ToggleVoteMutationOptions = Apollo.BaseMutationOptions<ToggleVoteMutation, ToggleVoteMutationVariables>;